/* eslint-disable */
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: number;
};

/** General channel info, common to all channel with the same type */
export type AllChannelType = {
   __typename: 'AllChannelType';
  email: Maybe<ChannelType>;
  messenger: Maybe<ChannelType>;
  sanuker: Maybe<ChannelType>;
  wechat: Maybe<ChannelType>;
  whatsapp: Maybe<ChannelType>;
  whatsapp2: Maybe<ChannelType>;
};

export type AllCompanyChannel = {
   __typename: 'AllCompanyChannel';
  email: Array<Email>;
  messenger: Array<Messenger>;
  sanuker: Array<Sanuker>;
  wechat: Array<Wechat>;
  whatsapp: Array<Whatsapp>;
  whatsapp2: Array<Whatsapp2>;
};

export type AnalyticsPlatformInt = {
   __typename: 'AnalyticsPlatformInt';
  aggregated: Scalars['Int'];
  email: Scalars['Int'];
  facebookFeed: Scalars['Int'];
  facebookMessaging: Scalars['Int'];
  instagramMessaging: Scalars['Int'];
  instagramPost: Scalars['Int'];
  wechat: Scalars['Int'];
  whatsapp: Scalars['Int'];
};

export type AnalyticsPlatformIntSeries = {
   __typename: 'AnalyticsPlatformIntSeries';
  aggregated: Scalars['Int'];
  email: Array<Scalars['Int']>;
  facebookFeed: Array<Scalars['Int']>;
  facebookMessaging: Array<Scalars['Int']>;
  instagramMessaging: Array<Scalars['Int']>;
  instagramPost: Array<Scalars['Int']>;
  wechat: Array<Scalars['Int']>;
  whatsapp: Array<Scalars['Int']>;
};

export type AnalyticsPlatformNullableIntSeries = {
   __typename: 'AnalyticsPlatformNullableIntSeries';
  aggregated: Maybe<Scalars['Int']>;
  email: Array<Maybe<Scalars['Int']>>;
  facebookFeed: Array<Maybe<Scalars['Int']>>;
  facebookMessaging: Array<Maybe<Scalars['Int']>>;
  instagramMessaging: Array<Maybe<Scalars['Int']>>;
  instagramPost: Array<Maybe<Scalars['Int']>>;
  wechat: Array<Maybe<Scalars['Int']>>;
  whatsapp: Array<Maybe<Scalars['Int']>>;
};

export type AssignedConversationCount = {
   __typename: 'AssignedConversationCount';
  count: Scalars['Int'];
  userId: Scalars['String'];
};

export type Attachment = {
   __typename: 'Attachment';
  type: Scalars['Int'];
  assetId: Scalars['String'];
  url: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  size: Scalars['Int'];
  contentId: Maybe<Scalars['String']>;
  filename: Maybe<Scalars['String']>;
  contentType: Scalars['String'];
};

export type AttachmentInput = {
  type: Scalars['Int'];
  assetId: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  size: Scalars['Int'];
  contentId: Maybe<Scalars['String']>;
  filename: Maybe<Scalars['String']>;
  contentType: Scalars['String'];
};

export type AuthOtpResponse = {
   __typename: 'AuthOTPResponse';
  otp: Scalars['String'];
};

/**
 * only contains part of the fields in Message type
 * to avoid infinite recursion and unwanted cache update
 * due to some fields is not fetched from database
 */
export type BaseMessage = {
   __typename: 'BaseMessage';
  id: Scalars['ID'];
  inbound: Scalars['Boolean'];
  staffId: Maybe<Scalars['ID']>;
  profileId: Maybe<Scalars['ID']>;
  staffName: Scalars['String'];
  timestamp: Scalars['Date'];
  content: Scalars['String'];
  emailExtra: Maybe<EmailExtra>;
  facebookExtra: Maybe<FacebookExtra>;
  orderStatusExtra: Maybe<OrderStatusExtra>;
  sanukerTemplateExtra: Maybe<Scalars['String']>;
  edited: Scalars['Boolean'];
  removed: Scalars['Boolean'];
  isBot: Scalars['Boolean'];
  type: MessageType;
  attachments: Array<Attachment>;
  hasRead: Scalars['Boolean'];
  isInternal: Scalars['Boolean'];
};

export type BaseQuickReplyCategory = {
   __typename: 'BaseQuickReplyCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum BillingType {
  Fixed = 'FIXED',
  Perseat = 'PERSEAT'
}

export type BroadcastCampaign = {
   __typename: 'BroadcastCampaign';
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  modifiedAt: Scalars['Date'];
  companyId: Scalars['String'];
  title: Scalars['String'];
  deliveryAt: Maybe<Scalars['Date']>;
  broadcastStatus: BroadcastCampaignStatus;
  deliveryCount: Scalars['Int'];
  processed: Scalars['Int'];
  sent: Scalars['Int'];
  deliveries: Maybe<Array<BroadcastCampaignDelivery>>;
  channelId: Scalars['ID'];
  externalChannelId: Maybe<Scalars['String']>;
  templateId: Maybe<Scalars['ID']>;
  templateArg: Maybe<TemplateArgument>;
  retries: Maybe<Array<BroadcastCampaignRetry>>;
};

export type BroadcastCampaignDelivery = {
   __typename: 'BroadcastCampaignDelivery';
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  modifiedAt: Scalars['Date'];
  broadcastCampaignId: Scalars['String'];
  profile: Maybe<Profile>;
  processedAt: Maybe<Scalars['Date']>;
  deliveryStatus: BroadcastDeliveryStatus;
  message: Maybe<Message>;
};

export type BroadcastCampaignList = {
   __typename: 'BroadcastCampaignList';
  broadcastCampaigns: Array<BroadcastCampaign>;
  total: Scalars['Int'];
};

export type BroadcastCampaignRetry = {
   __typename: 'BroadcastCampaignRetry';
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  modifiedAt: Scalars['Date'];
  broadcastCampaignId: Scalars['String'];
  retryStatus: BroadcastRetryStatus;
  retriedAt: Scalars['Date'];
};

export enum BroadcastCampaignStatus {
  Draft = 'DRAFT',
  Scheduled = 'SCHEDULED',
  Sending = 'SENDING',
  Completed = 'COMPLETED'
}

export enum BroadcastDeliveryStatus {
  Pending = 'PENDING',
  Enqueued = 'ENQUEUED',
  Sent = 'SENT',
  Failed = 'FAILED'
}

export type BroadcastMessageHistory = {
   __typename: 'BroadcastMessageHistory';
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  broadcastMessage: Maybe<Message>;
  individualConversation: Maybe<Conversation>;
  messageId: Maybe<Scalars['ID']>;
  sentAt: Maybe<Scalars['Date']>;
  status: Scalars['Int'];
};

export type BroadcastMessageResponse = {
   __typename: 'BroadcastMessageResponse';
  broadcastMessage: Message;
  broadcastConversation: Conversation;
};

export enum BroadcastRetryStatus {
  Sending = 'SENDING',
  Completed = 'COMPLETED'
}

export type BroadcastStatus = {
   __typename: 'BroadcastStatus';
  id: Scalars['ID'];
  broadcastMessageNumber: Maybe<Scalars['Int']>;
  broadcastMessage: Maybe<Message>;
  individualConversation: Maybe<Conversation>;
  recipient: Maybe<Scalars['String']>;
  currentStatus: Scalars['Int'];
  lastUpdated: Scalars['Date'];
  histories: Array<BroadcastMessageHistory>;
};

export type BroadcastStatusListResponse = {
   __typename: 'BroadcastStatusListResponse';
  statusList: Array<BroadcastStatus>;
  total: Scalars['Int'];
};

export type Capabilities = {
   __typename: 'Capabilities';
  broadcastCampaignOp: Scalars['Boolean'];
  channelBypass: Scalars['Boolean'];
  companyAnalyticsOp: Scalars['Boolean'];
  companyBillingOp: Scalars['Boolean'];
  companyBypass: Scalars['Boolean'];
  companyChannelOp: Scalars['Boolean'];
  companyCommerceOp: Scalars['Boolean'];
  companyCreateOp: Scalars['Boolean'];
  companyCrmOp: Scalars['Boolean'];
  companyIntegrationKeyOp: Scalars['Boolean'];
  companyPaymentOp: Scalars['Boolean'];
  companyProfileOp: Scalars['Boolean'];
  companyQuickReplyOp: Scalars['Boolean'];
  companyTagOp: Scalars['Boolean'];
  companyTeamOp: Scalars['Boolean'];
  companyUserOp: Scalars['Boolean'];
  conversationAllAssignee: Scalars['Boolean'];
  conversationOp: Scalars['Boolean'];
  conversationReassignOp: Scalars['Boolean'];
  conversationTakeUnassignedOp: Scalars['Boolean'];
  customerOp: Scalars['Boolean'];
  productOp: Scalars['Boolean'];
  quickReplyOp: Scalars['Boolean'];
  roleOp: Scalars['Boolean'];
  templateMessageOp: Scalars['Boolean'];
};

export type CapabilitiesArgs = {
  broadcastCampaignOp: Maybe<Scalars['Boolean']>;
  channelBypass: Maybe<Scalars['Boolean']>;
  companyAnalyticsOp: Maybe<Scalars['Boolean']>;
  companyBillingOp: Maybe<Scalars['Boolean']>;
  companyChannelOp: Maybe<Scalars['Boolean']>;
  companyCommerceOp: Maybe<Scalars['Boolean']>;
  companyCrmOp: Maybe<Scalars['Boolean']>;
  companyIntegrationKeyOp: Maybe<Scalars['Boolean']>;
  companyPaymentOp: Maybe<Scalars['Boolean']>;
  companyProfileOp: Maybe<Scalars['Boolean']>;
  companyQuickReplyOp: Maybe<Scalars['Boolean']>;
  companyTagOp: Maybe<Scalars['Boolean']>;
  companyTeamOp: Maybe<Scalars['Boolean']>;
  companyUserOp: Maybe<Scalars['Boolean']>;
  conversationAllAssignee: Maybe<Scalars['Boolean']>;
  conversationOp: Maybe<Scalars['Boolean']>;
  conversationReassignOp: Maybe<Scalars['Boolean']>;
  conversationTakeUnassignedOp: Maybe<Scalars['Boolean']>;
  customerOp: Maybe<Scalars['Boolean']>;
  productOp: Maybe<Scalars['Boolean']>;
  quickReplyOp: Maybe<Scalars['Boolean']>;
  roleOp: Maybe<Scalars['Boolean']>;
  templateMessageOp: Maybe<Scalars['Boolean']>;
};

export enum ChannelSlug {
  Email = 'Email',
  Messenger = 'Messenger',
  Sanuker = 'Sanuker',
  Wechat = 'Wechat',
  Whatsapp = 'Whatsapp',
  Whatsapp2 = 'Whatsapp2'
}

export enum ChannelStatus {
  ChatApiGotQrCode = 'CHAT_API_GOT_QR_CODE',
  ChatApiLoading = 'CHAT_API_LOADING',
  ChatApiPhoneNotConnected = 'CHAT_API_PHONE_NOT_CONNECTED',
  ChatApiUnauthorized = 'CHAT_API_UNAUTHORIZED',
  FbTokenExpired = 'FB_TOKEN_EXPIRED',
  IncorrectInstagramAccountType = 'INCORRECT_INSTAGRAM_ACCOUNT_TYPE',
  InstagramMessagingAccessDenied = 'INSTAGRAM_MESSAGING_ACCESS_DENIED',
  Normal = 'NORMAL',
  TwilioUnauthorized = 'TWILIO_UNAUTHORIZED',
  Unknown = 'UNKNOWN'
}

export type ChannelType = {
   __typename: 'ChannelType';
  /** Channel connection service availability */
  isAvailable: Scalars['Boolean'];
  /** Timeout, in seconds, for replying a messenge to sender. 0 for unlimited. */
  replayTimeout: Scalars['Int'];
  slug: ChannelSlug;
};

export type CheckPaymentSubscriptionCompletedResponse = {
   __typename: 'CheckPaymentSubscriptionCompletedResponse';
  isCompleted: Scalars['Boolean'];
};

export type CheckStripeSubscriptionCompletedResponse = {
   __typename: 'CheckStripeSubscriptionCompletedResponse';
  isCompleted: Scalars['Boolean'];
};

export type Company = {
   __typename: 'Company';
  affiliateDefinition: Maybe<CompanyAffiliateDefinition>;
  channels: AllCompanyChannel;
  defaultCustomerPortalLocale: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  hasSubscriptionPlan: Scalars['Boolean'];
  /** logo asset id */
  logo: Maybe<Scalars['String']>;
  logoUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  onboardingProgress: CompanyOnboardingStep;
  slug: Scalars['ID'];
  subscriptionPlan: Maybe<SubscriptionPlan>;
  subscriptionWillEndAt: Maybe<Scalars['Date']>;
  suspended: Scalars['Boolean'];
};

export enum CompanyAccountStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type CompanyAffiliateDefinition = {
   __typename: 'CompanyAffiliateDefinition';
  domains: Array<Scalars['String']>;
  queryParams: Array<Scalars['String']>;
};

/** Connected channel info, specific to each company channel */
export type CompanyChannel = {
  accountId: Maybe<Scalars['ID']>;
  channelType: ChannelType;
  creatorName: Maybe<Scalars['String']>;
  customName: Maybe<Scalars['String']>;
  defaultRoutedTeamId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  partialAccountSecret: Maybe<Scalars['String']>;
  status: ChannelStatus;
};

export type CompanyChannelInfo = {
   __typename: 'CompanyChannelInfo';
  channelType: ChannelType;
  creatorName: Scalars['String'];
  customName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  status: ChannelStatus;
};

export type CompanyChannelStatusHistory = {
   __typename: 'CompanyChannelStatusHistory';
  status: ChannelStatus;
  substatus: Maybe<Scalars['String']>;
  timestamp: Scalars['Date'];
};

/** Connected commerce info, specific to each company commerce */
export type CompanyCommerce = {
  accountId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CompanyCommerceCreateRequestArgs = {
  shopify: Maybe<ShopifyCreateCommerceRequestArgs>;
};

export type CompanyCrm = {
   __typename: 'CompanyCrm';
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  syncContact: Scalars['Boolean'];
  syncConversation: Scalars['Boolean'];
  type: CrmType;
};

export type CompanyInfo = {
   __typename: 'CompanyInfo';
  accountStatus: CompanyAccountStatus;
  companyCreatedAt: Scalars['Date'];
  companySlug: Scalars['ID'];
  connectedChannels: AllCompanyChannel;
  firstSubscriptionDate: Maybe<Scalars['Date']>;
  isSuspended: Scalars['Boolean'];
  name: Scalars['String'];
  primaryUser: Maybe<CompanyPrimaryUserInfo>;
  referrer: Maybe<Scalars['String']>;
  subscriptionPlan: Maybe<SubscriptionPlan>;
  unsubscribeDate: Maybe<Scalars['Date']>;
};

export enum CompanyOnboardingStep {
  CompanyCreated = 'COMPANY_CREATED',
  SeenChannelGuide = 'SEEN_CHANNEL_GUIDE'
}

/** First user of company, point of contact */
export type CompanyPrimaryUserInfo = {
   __typename: 'CompanyPrimaryUserInfo';
  email: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone: Maybe<Scalars['String']>;
};

export type Conversation = {
   __typename: 'Conversation';
  id: Scalars['ID'];
  companyId: Scalars['String'];
  channelId: Scalars['String'];
  channelType: Scalars['String'];
  channelName: Maybe<Scalars['String']>;
  channelSubType: Maybe<Scalars['String']>;
  accountId: Scalars['String'];
  externalChannelId: Maybe<Scalars['String']>;
  peer: Scalars['String'];
  assignee: Maybe<Scalars['String']>;
  assigneeAlert: Scalars['Boolean'];
  permaLink: Maybe<Scalars['String']>;
  isArchived: Scalars['Boolean'];
  isDisconnected: Scalars['Boolean'];
  unreadCount: Scalars['Int'];
  lastMessage: Maybe<BaseMessage>;
  profile: Maybe<Profile>;
  post: Maybe<Post>;
  subject: Maybe<Scalars['String']>;
  lastInboundTimestamp: Maybe<Scalars['Date']>;
  lockStatus: Scalars['Int'];
  verificationStatus: Scalars['Int'];
  isLiveChat: Scalars['Boolean'];
  assigneeName: Maybe<Scalars['String']>;
  assigneePortraitUrl: Maybe<Scalars['String']>;
  tags: Array<ConversationTag>;
  isBroadcast: Scalars['Boolean'];
  customerCount: Scalars['Int'];
  usedFacebookPrivateReply: Scalars['Boolean'];
  createdAt: Scalars['Date'];
  channelStatus: ChannelStatus;
  lastMessageCursor: Maybe<Scalars['String']>;
  routedTeam: Maybe<Team>;
  supportUsers: Array<SupportUser>;
  isMarkedActionTaken: Scalars['Boolean'];
};

export type ConversationChannelFilterInput = {
  channelId: Scalars['ID'];
  channelSubType: Maybe<Scalars['String']>;
  externalChannelId: Maybe<Scalars['String']>;
};

export type ConversationCount = {
   __typename: 'ConversationCount';
  active: Scalars['Int'];
  notReplied: Scalars['Int'];
  unassigned: Scalars['Int'];
};

export type ConversationCountOfSection = {
   __typename: 'ConversationCountOfSection';
  section: Scalars['String'];
  count: Scalars['Int'];
};

export type ConversationTag = {
   __typename: 'ConversationTag';
  tag: Tag;
  createdAt: Scalars['Date'];
};

export type ConversationTagFilterInput = {
  assignee: Maybe<Scalars['String']>;
  channelType: Maybe<Scalars['String']>;
  excludeBroadcast: Maybe<Scalars['Boolean']>;
  externalChannelId: Maybe<Scalars['String']>;
};

export type CreateCompanyArgs = {
  /** logo asset id */
  logo: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  subscriptionPlan: Scalars['String'];
};

export type CreateCompanyUserArgs = {
  email: Maybe<Scalars['String']>;
  loginId: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  phone: Maybe<Scalars['String']>;
  role: Scalars['String'];
  staffCode: Maybe<Scalars['String']>;
};

export type CreateCompanyWithUserArgs = {
  companyName: Scalars['String'];
  companySlug: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  phone: Maybe<Scalars['String']>;
  referralCode: Maybe<Scalars['String']>;
  referrer: Maybe<Scalars['String']>;
};

export type CreateCompanyWithUserResponse = {
   __typename: 'CreateCompanyWithUserResponse';
  company: Company;
  user: User;
};

export type CreateProductArgs = {
  currency: Scalars['String'];
  description: Maybe<Scalars['String']>;
  /** images asset ids */
  images: Array<Scalars['String']>;
  name: Scalars['String'];
  shipmentRequired: Scalars['Boolean'];
  sku: Maybe<Scalars['String']>;
  status: ProductStatus;
  summary: Maybe<Scalars['String']>;
  unitPrice: Scalars['String'];
};

export type CreateShopifyAuthorizeLinkResponse = {
   __typename: 'CreateShopifyAuthorizeLinkResponse';
  authorizeLink: Scalars['String'];
};

export type CreateTagArgs = {
  name: Scalars['String'];
};

export type CreateTeamArgs = {
  name: Scalars['String'];
  teamUsers: Array<CreateTeamUser>;
  isCollaborative: Scalars['Boolean'];
  autoCompleteIdleDays: Maybe<Scalars['Int']>;
};

export type CreateTeamUser = {
  userId: Scalars['ID'];
  isTeamManager: Scalars['Boolean'];
};

export enum CrmType {
  Hubspot = 'Hubspot'
}

export type CustomerAddress = {
   __typename: 'CustomerAddress';
  address1: Maybe<Scalars['String']>;
  address2: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type: CustomerAddressType;
};

export enum CustomerAddressType {
  Billing = 'BILLING',
  Shipping = 'SHIPPING'
}

export type CustomerConversation = {
   __typename: 'CustomerConversation';
  id: Scalars['ID'];
  assignee: Maybe<Scalars['String']>;
  assigneeName: Maybe<Scalars['String']>;
  assigneePortraitUrl: Maybe<Scalars['String']>;
};

export type CustomerInfo = {
   __typename: 'CustomerInfo';
  profileId: Scalars['String'];
  name: Scalars['String'];
  portraitUrl: Maybe<Scalars['String']>;
  conversationId: Maybe<Scalars['String']>;
  conversationAssignee: Maybe<Scalars['String']>;
  channelType: Maybe<Scalars['String']>;
  channelSubType: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  conversationCreatedByBroadcast: Maybe<Scalars['Boolean']>;
  tags: Maybe<Array<Tag>>;
};

export type CustomerInitialPaymentInput = {
  paymentMethodId: Scalars['ID'];
  customer: CustomerSubmitCustomerInput;
  shippingSave: Scalars['Boolean'];
  shipping: Maybe<CustomerSubmitAddressInput>;
  billingSave: Scalars['Boolean'];
  billing: Maybe<CustomerSubmitAddressInput>;
};

export type CustomerOrderResponse = {
   __typename: 'CustomerOrderResponse';
  order: ReducedOrder;
  shippingInfo: ReducedShippingInfo;
  billingAddress: Maybe<ReducedBillingAddress>;
  statusHistories: Array<ReducedOrderStatusHistory>;
  payments: Array<ReducedPayment>;
};

export type CustomerPaymentInitiateResponse = {
   __typename: 'CustomerPaymentInitiateResponse';
  id: Scalars['ID'];
  token: Scalars['String'];
  publishableKey: Maybe<Scalars['String']>;
};

export type CustomerRequestPresignUploadInput = {
  contentType: Scalars['String'];
  contentLength: Scalars['Int'];
  isPublic: Scalars['Boolean'];
};

export type CustomerRequestPresignUploadResponse = {
   __typename: 'CustomerRequestPresignUploadResponse';
  assetId: Scalars['String'];
  url: Scalars['String'];
  method: Scalars['String'];
  headers: Array<PresignRequestHeader>;
};

export type CustomerSubmitAddressInput = {
  country: Scalars['String'];
  address1: Scalars['String'];
  address2: Scalars['String'];
};

export type CustomerSubmitCustomerInput = {
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type CustomerSubmitInput = {
  token: Scalars['String'];
  customer: CustomerSubmitCustomerInput;
  shipping: CustomerSubmitAddressInput;
  shippingSave: Scalars['Boolean'];
  receipt: Scalars['String'];
  paymentMethodId: Maybe<Scalars['ID']>;
};

export type CustomerUpdateOrderArgs = {
  portalLocale: Maybe<Scalars['String']>;
};


export type DeleteTagArgs = {
  tagId: Scalars['ID'];
};

export type DetailedMatchMessage = {
   __typename: 'DetailedMatchMessage';
  match: MatchMessage;
  relatedConversation: Conversation;
};

export type Email = CompanyChannel & {
   __typename: 'Email';
  accountId: Maybe<Scalars['ID']>;
  channelType: ChannelType;
  creatorName: Maybe<Scalars['String']>;
  customName: Maybe<Scalars['String']>;
  defaultRoutedTeamId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  partialAccountSecret: Maybe<Scalars['String']>;
  status: ChannelStatus;
};

export type EmailExtra = {
   __typename: 'EmailExtra';
  from: Maybe<Array<NameEmail>>;
  replyTo: Maybe<Array<NameEmail>>;
  to: Maybe<Array<NameEmail>>;
  cc: Maybe<Array<NameEmail>>;
  bcc: Maybe<Array<NameEmail>>;
};

export type EmailOAuth = {
  code: Scalars['String'];
};

export type EmailOutboundExtraInput = {
  to: Maybe<Array<NameEmailInput>>;
  cc: Maybe<Array<NameEmailInput>>;
  bcc: Maybe<Array<NameEmailInput>>;
};

export enum ErrorCode {
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  BadRequest = 'BAD_REQUEST',
  AuthFailed = 'AUTH_FAILED',
  BadSlug = 'BAD_SLUG',
  UserExists = 'USER_EXISTS',
  CompanyExists = 'COMPANY_EXISTS',
  RoleNameExists = 'ROLE_NAME_EXISTS',
  CompanyNotFound = 'COMPANY_NOT_FOUND',
  ChannelOccupied = 'CHANNEL_OCCUPIED',
  ChannelConnectFailed = 'CHANNEL_CONNECT_FAILED',
  ChannelDeleteFailed = 'CHANNEL_DELETE_FAILED',
  InvitationUserExists = 'INVITATION_USER_EXISTS',
  InvitationInvalidCode = 'INVITATION_INVALID_CODE',
  QuotaExceed = 'QUOTA_EXCEED',
  ProductSkuConflict = 'PRODUCT_SKU_CONFLICT',
  CompanySuspended = 'COMPANY_SUSPENDED',
  InvalidRecipient = 'INVALID_RECIPIENT',
  ImportCustomerDraftInvalidCsv = 'IMPORT_CUSTOMER_DRAFT_INVALID_CSV',
  CommerceConflict = 'COMMERCE_CONFLICT',
  ConversationConflict = 'CONVERSATION_CONFLICT',
  CommerceCompanyConnected = 'COMMERCE_COMPANY_CONNECTED',
  TeamNameExists = 'TEAM_NAME_EXISTS',
  TeamUserDuplicated = 'TEAM_USER_DUPLICATED',
  ConversationAlreadyPickedUp = 'CONVERSATION_ALREADY_PICKED_UP',
  QuickReplyNameExists = 'QUICK_REPLY_NAME_EXISTS',
  QuickReplyCategoryNameExists = 'QUICK_REPLY_CATEGORY_NAME_EXISTS'
}

export type ExternalChannel = {
   __typename: 'ExternalChannel';
  externalChannelId: Scalars['String'];
  externalChannelType: Scalars['String'];
  name: Scalars['String'];
};

export type FacebookChannelConfig = {
   __typename: 'FacebookChannelConfig';
  enableFeed: Scalars['Boolean'];
  enableInstagramMessaging: Scalars['Boolean'];
  enableInstagramPost: Scalars['Boolean'];
  enableMessaging: Scalars['Boolean'];
};

export type FacebookExtra = {
   __typename: 'FacebookExtra';
  isStoryReply: Scalars['Boolean'];
  isStoryMention: Scalars['Boolean'];
};

export type FacebookMessengerOAuth = {
  accessToken: Scalars['String'];
  enableFeed: Scalars['Boolean'];
  enableInstagramMessaging: Scalars['Boolean'];
  enableInstagramPost: Scalars['Boolean'];
  enableMessaging: Scalars['Boolean'];
  pageId: Scalars['String'];
};

export type GroupNote = {
   __typename: 'GroupNote';
  id: Scalars['ID'];
  edited: Scalars['Boolean'];
  latestHistory: Maybe<GroupNoteHistory>;
};

export type GroupNoteHistory = {
   __typename: 'GroupNoteHistory';
  createdAt: Scalars['Date'];
  createdBy: Maybe<Scalars['String']>;
  content: Scalars['String'];
};

export type HubspotOAuth = {
  code: Scalars['String'];
};

export type Image = {
   __typename: 'Image';
  assetId: Scalars['String'];
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type ImportCustomersConfirmResponse = {
   __typename: 'ImportCustomersConfirmResponse';
  customerCreatedCount: Scalars['Int'];
  customerEditedCount: Scalars['Int'];
  customerUnchangedCount: Scalars['Int'];
};

export type ImportCustomersDraftResponse = {
   __typename: 'ImportCustomersDraftResponse';
  importCustomerId: Scalars['ID'];
  customerCreatedCount: Scalars['Int'];
  customerEditedCount: Scalars['Int'];
  customerUnchangedCount: Scalars['Int'];
};

export type InitiateConversationMessageArgs = {
  pendingId: Maybe<Scalars['String']>;
  subject: Maybe<Scalars['String']>;
  content: Scalars['String'];
  attachments: Maybe<Array<AttachmentInput>>;
  templateId: Maybe<Scalars['String']>;
  templateArg: Maybe<TemplateArgumentInput>;
  emailExtra: Maybe<EmailOutboundExtraInput>;
  whatsappExtra: Maybe<WhatsappOutboundExtraInput>;
};

export type InitiateConversationProfileArgs = {
  name: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
};

export type InitiateConversationResponse = {
   __typename: 'InitiateConversationResponse';
  message: Message;
  conversation: Conversation;
};

export type InitiateConversationWithFbFeedResponse = {
   __typename: 'InitiateConversationWithFbFeedResponse';
  message: Message;
  conversation: Conversation;
};

export type InitiateConversationWithPostCommentResponse = {
   __typename: 'InitiateConversationWithPostCommentResponse';
  message: Message;
  conversation: Conversation;
};

export type InitiateConversationWithProfileResponse = {
   __typename: 'InitiateConversationWithProfileResponse';
  conversation: Conversation;
};

export type IntegrationKeyResponse = {
   __typename: 'IntegrationKeyResponse';
  zapierIntegrationKey: Maybe<Scalars['String']>;
};

export enum IntervalType {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type Invitation = {
   __typename: 'Invitation';
  createdAt: Scalars['Date'];
  email: Scalars['String'];
  id: Scalars['ID'];
  isExpired: Scalars['Boolean'];
  name: Scalars['String'];
  phone: Maybe<Scalars['String']>;
  role: Role;
};

export type InviteCompanyUserByEmailArgs = {
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Maybe<Scalars['String']>;
  role: Scalars['String'];
};

export type InviteConfirmResponse = {
   __typename: 'InviteConfirmResponse';
  email: Scalars['String'];
};

export type LineItemInput = {
  id: Scalars['Float'];
  quantity: Scalars['Int'];
};

export type ListCompanyInfoResponse = {
   __typename: 'ListCompanyInfoResponse';
  companyInfoList: Array<CompanyInfo>;
  total: Scalars['Int'];
};

export type ManagedTeam = {
   __typename: 'ManagedTeam';
  id: Scalars['ID'];
  name: Scalars['String'];
  isCollaborative: Scalars['Boolean'];
};

export type ManagedTeamUser = {
   __typename: 'ManagedTeamUser';
  user: User;
  managedTeams: Array<ManagedTeam>;
};

export type ManagedTeamUserList = {
   __typename: 'ManagedTeamUserList';
  managedTeamUsers: Array<ManagedTeamUser>;
};

export type MatchMessage = {
   __typename: 'MatchMessage';
  message: Message;
  cursor: Scalars['String'];
};

export type Message = {
   __typename: 'Message';
  id: Scalars['ID'];
  companyId: Scalars['String'];
  conversationId: Scalars['String'];
  inbound: Scalars['Boolean'];
  status: MessageStatus;
  staffId: Maybe<Scalars['ID']>;
  profileId: Maybe<Scalars['ID']>;
  staffName: Scalars['String'];
  timestamp: Scalars['Date'];
  content: Scalars['String'];
  emailExtra: Maybe<EmailExtra>;
  facebookExtra: Maybe<FacebookExtra>;
  pendingId: Maybe<Scalars['String']>;
  edited: Scalars['Boolean'];
  removed: Scalars['Boolean'];
  isBot: Scalars['Boolean'];
  isBroadcast: Scalars['Boolean'];
  usedFacebookPrivateReply: Scalars['Boolean'];
  type: MessageType;
  orderStatusExtra: Maybe<OrderStatusExtra>;
  paymentExtra: Maybe<PaymentExtra>;
  sanukerTemplateExtra: Maybe<Scalars['String']>;
  interactiveDataExtra: Maybe<Scalars['String']>;
  order: Maybe<Order>;
  hasRead: Scalars['Boolean'];
  isInternal: Scalars['Boolean'];
  replyToMessage: Maybe<BaseMessage>;
  attachments: Array<Attachment>;
};

export enum MessageListDirection {
  Before = 'Before',
  After = 'After'
}

export type MessageListResponse = {
   __typename: 'MessageListResponse';
  messages: Array<Message>;
  next: Scalars['String'];
};

export enum MessageStatus {
  Initial = 'INITIAL',
  PendingRetry = 'PENDING_RETRY',
  IsRetrying = 'IS_RETRYING',
  Error = 'ERROR',
  Delivered = 'DELIVERED'
}

export enum MessageType {
  Chat = 'CHAT',
  OrderStatus = 'ORDER_STATUS',
  Payment = 'PAYMENT',
  SanukerTemplate = 'SANUKER_TEMPLATE'
}

export type MessageWithReplies = {
   __typename: 'MessageWithReplies';
  id: Scalars['ID'];
  companyId: Scalars['String'];
  conversationId: Scalars['String'];
  inbound: Scalars['Boolean'];
  status: MessageStatus;
  staffId: Maybe<Scalars['ID']>;
  profileId: Maybe<Scalars['ID']>;
  staffName: Scalars['String'];
  timestamp: Scalars['Date'];
  content: Scalars['String'];
  emailExtra: Maybe<EmailExtra>;
  facebookExtra: Maybe<FacebookExtra>;
  pendingId: Maybe<Scalars['String']>;
  edited: Scalars['Boolean'];
  removed: Scalars['Boolean'];
  isBot: Scalars['Boolean'];
  isBroadcast: Scalars['Boolean'];
  usedFacebookPrivateReply: Scalars['Boolean'];
  type: MessageType;
  orderStatusExtra: Maybe<OrderStatusExtra>;
  paymentExtra: Maybe<PaymentExtra>;
  sanukerTemplateExtra: Maybe<Scalars['String']>;
  interactiveDataExtra: Maybe<Scalars['String']>;
  order: Maybe<Order>;
  hasRead: Scalars['Boolean'];
  isInternal: Scalars['Boolean'];
  replies: Maybe<Array<Message>>;
  replyToMessage: Maybe<BaseMessage>;
  attachments: Array<Attachment>;
};

export type Messenger = CompanyChannel & {
   __typename: 'Messenger';
  accountId: Maybe<Scalars['ID']>;
  channelType: ChannelType;
  config: FacebookChannelConfig;
  creatorName: Maybe<Scalars['String']>;
  customName: Maybe<Scalars['String']>;
  defaultRoutedTeamId: Maybe<Scalars['ID']>;
  facebookPageId: Scalars['String'];
  facebookPageLink: Scalars['String'];
  id: Scalars['ID'];
  instagramUsername: Maybe<Scalars['String']>;
  name: Scalars['String'];
  partialAccountSecret: Maybe<Scalars['String']>;
  status: ChannelStatus;
};

export type Mutation = {
   __typename: 'Mutation';
  AddGroupNote: GroupNote;
  AddNote: Note;
  AddSupportUsers: Conversation;
  ArchiveConversation: Conversation;
  Assign: Conversation;
  AssignRole: User;
  AttachTag: ConversationTag;
  BroadcastMessage: BroadcastMessageResponse;
  ConfirmInvitation: InviteConfirmResponse;
  ConfirmReceipt: Payment;
  ConsumeInvitation: Scalars['Boolean'];
  CreateBroadcastCampaign: BroadcastCampaign;
  CreateCompany: Company;
  CreateCompanyCommerce: CompanyCommerce;
  CreateCompanyUser: User;
  CreateCompanyWithUser: CreateCompanyWithUserResponse;
  CreateEmailChannel: Email;
  CreateFacebookMessengerChannel: Messenger;
  CreateHubspotCrm: CompanyCrm;
  CreateMessage: Message;
  CreateOrUpdatePaymentMethod: PaymentMethod;
  CreateOrder: Order;
  CreateOrderNote: OrderNote;
  CreateProduct: Product;
  CreateQuickReplyCategoryRequest: QuickReplyCategoryResponse;
  CreateQuickReplyRequest: QuickReplyResponse;
  CreateRole: Role;
  CreateShopifyAuthorizeLink: CreateShopifyAuthorizeLinkResponse;
  CreateShopifyOrder: Maybe<Scalars['Boolean']>;
  CreateShopifySubscription: ShopifySubscriptionCreateResponse;
  CreateSubscription: SubscriptionCreateResponse;
  CreateSubscriptionPortalSession: SubscriptionPortalSessionCreateResponse;
  CreateTag: Tag;
  CreateTeam: Team;
  CreateUserOtp: UserOtp;
  CreateWhatsapp2Channel: Whatsapp2;
  CreateWhatsappChannel: Whatsapp;
  CustomerCancelPayment: Payment;
  CustomerInitiatePayment: CustomerPaymentInitiateResponse;
  CustomerQueryPayment: Payment;
  CustomerRemoveAddress: Scalars['Boolean'];
  CustomerRequestPresignUpload: CustomerRequestPresignUploadResponse;
  CustomerSubmit: Scalars['Boolean'];
  CustomerUpdateOrder: CustomerOrderResponse;
  DeleteCompanyChannel: Scalars['ID'];
  DeleteCompanyCommerce: Maybe<Scalars['Boolean']>;
  DeleteInvitation: Scalars['Boolean'];
  DeleteOrderNote: Maybe<Scalars['Boolean']>;
  DeleteQuickReplyCategoryRequest: Scalars['Boolean'];
  DeleteQuickReplyRequest: Scalars['Boolean'];
  DeleteRole: Scalars['Boolean'];
  DeleteTag: Scalars['ID'];
  DetachTag: Scalars['ID'];
  ImportCustomersConfirm: ImportCustomersConfirmResponse;
  ImportCustomersDraft: ImportCustomersDraftResponse;
  InitiateConversation: InitiateConversationResponse;
  InitiateConversationWithFbFeed: InitiateConversationWithFbFeedResponse;
  InitiateConversationWithPostComment: InitiateConversationWithPostCommentResponse;
  InitiateConversationWithProfile: InitiateConversationWithProfileResponse;
  InviteCompanyUserByEmail: Scalars['Boolean'];
  Leave: Conversation;
  MarkActionTaken: Conversation;
  MarkCreatedByBroadcast: Conversation;
  MarkRead: Conversation;
  Pickup: Conversation;
  PushSubscribe: Scalars['Boolean'];
  PushUnsubscribe: Scalars['Boolean'];
  RejectReceipt: Payment;
  RemoveBroadcastCampaign: Scalars['Boolean'];
  RemoveCompanyCrm: Scalars['Boolean'];
  RemoveConversation: Scalars['ID'];
  RemoveGroupNote: Scalars['Boolean'];
  RemoveMessage: Scalars['ID'];
  RemoveNote: Scalars['Boolean'];
  RemoveProduct: Scalars['Boolean'];
  RemoveSupportUser: Conversation;
  Reroute: Conversation;
  ResetPassword: Scalars['Boolean'];
  RetryBroadcastCampaign: BroadcastCampaign;
  SendInternalMessage: Message;
  ShopifyOauthIntegration: CompanyCommerce;
  SubmitReceipt: Payment;
  SuspendCompany: Company;
  SuspendStaff: User;
  ToggleConversationLiveChat: Conversation;
  UnmarkActionTaken: Conversation;
  UnsuspendCompany: Company;
  UnsuspendStaff: User;
  UpdateBroadcastCampaign: BroadcastCampaign;
  UpdateCompany: Company;
  UpdateCompanyChannel: Company;
  UpdateCompanyCrm: CompanyCrm;
  UpdateCustomerPortalSettings: Company;
  UpdateCustomerProfile: Conversation;
  UpdateGroupNote: GroupNote;
  UpdateNote: Note;
  UpdateOnboardingProgress: Company;
  UpdateOrder: Order;
  UpdateOrderNote: OrderNote;
  UpdatePaymentSetting: PaymentSetting;
  UpdateProduct: Product;
  UpdateQuickReplyCategoryRequest: QuickReplyCategoryResponse;
  UpdateQuickReplyRequest: QuickReply;
  UpdateRole: Role;
  UpdateStaff: User;
  UpdateSubscriptionPlan: SubscriptionPlanUpdateResponse;
  UpdateTag: Tag;
  UpdateTeam: Team;
  UpdateTemplatePrefillValues: TemplateMessage;
  UpdateUser: User;
  deleteIntegrationKey: Maybe<Scalars['Boolean']>;
  generateIntegrationkey: IntegrationKeyResponse;
};


export type MutationAddGroupNoteArgs = {
  conversationId: Scalars['ID'];
  content: Scalars['String'];
};


export type MutationAddNoteArgs = {
  profileId: Scalars['ID'];
  content: Scalars['String'];
};


export type MutationAddSupportUsersArgs = {
  id: Scalars['ID'];
  supportUserIds: Array<Scalars['ID']>;
};


export type MutationArchiveConversationArgs = {
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
};


export type MutationAssignArgs = {
  id: Scalars['ID'];
  assignee: Scalars['ID'];
};


export type MutationAssignRoleArgs = {
  id: Scalars['ID'];
  role: Scalars['ID'];
  conversationAssignee: Maybe<Scalars['ID']>;
};


export type MutationAttachTagArgs = {
  conversationId: Scalars['ID'];
  tagName: Scalars['String'];
};


export type MutationBroadcastMessageArgs = {
  slug: Scalars['String'];
  broadcastConversationId: Maybe<Scalars['ID']>;
  channelId: Maybe<Scalars['ID']>;
  externalChannelId: Maybe<Scalars['String']>;
  subject: Maybe<Scalars['String']>;
  content: Scalars['String'];
  attachments: Maybe<Array<AttachmentInput>>;
  pendingId: Maybe<Scalars['String']>;
  templateId: Maybe<Scalars['String']>;
  selectedCustomersSelect: Maybe<SelectedCustomersSelectInput>;
  selectedCustomersSelectAll: Maybe<SelectedCustomersSelectAllInput>;
  emailExtra: Maybe<EmailOutboundExtraInput>;
  whatsappExtra: Maybe<WhatsappOutboundExtraInput>;
  templateArg: Maybe<TemplateArgumentInput>;
};


export type MutationConfirmInvitationArgs = {
  id: Scalars['ID'];
  code: Scalars['String'];
};


export type MutationConfirmReceiptArgs = {
  id: Scalars['ID'];
  isConfirmed: Scalars['Boolean'];
  slug: Scalars['ID'];
};


export type MutationConsumeInvitationArgs = {
  id: Scalars['ID'];
  code: Scalars['String'];
};


export type MutationCreateBroadcastCampaignArgs = {
  slug: Scalars['String'];
  title: Scalars['String'];
  channelId: Scalars['ID'];
  externalChannelId: Maybe<Scalars['String']>;
  subject: Maybe<Scalars['String']>;
  content: Maybe<Scalars['String']>;
  attachments: Maybe<Array<AttachmentInput>>;
  templateId: Maybe<Scalars['String']>;
  templateArg: Maybe<TemplateArgumentInput>;
  deliveryAt: Maybe<Scalars['Date']>;
  selectedCustomersSelect: Maybe<SelectedCustomersSelectInput>;
  selectedCustomersSelectAll: Maybe<SelectedCustomersSelectAllInput>;
  emailExtra: Maybe<EmailOutboundExtraInput>;
  whatsappExtra: Maybe<WhatsappOutboundExtraInput>;
  saveDraft: Scalars['Boolean'];
};


export type MutationCreateCompanyArgs = {
  args: CreateCompanyArgs;
};


export type MutationCreateCompanyCommerceArgs = {
  args: CompanyCommerceCreateRequestArgs;
  slug: Scalars['ID'];
};


export type MutationCreateCompanyUserArgs = {
  args: CreateCompanyUserArgs;
  slug: Scalars['ID'];
};


export type MutationCreateCompanyWithUserArgs = {
  args: CreateCompanyWithUserArgs;
};


export type MutationCreateEmailChannelArgs = {
  oauth: EmailOAuth;
  slug: Scalars['ID'];
};


export type MutationCreateFacebookMessengerChannelArgs = {
  messenger: FacebookMessengerOAuth;
  slug: Scalars['ID'];
};


export type MutationCreateHubspotCrmArgs = {
  input: HubspotOAuth;
  slug: Scalars['ID'];
};


export type MutationCreateMessageArgs = {
  conversationId: Scalars['ID'];
  subject: Maybe<Scalars['String']>;
  content: Scalars['String'];
  pendingId: Maybe<Scalars['String']>;
  templateId: Maybe<Scalars['String']>;
  emailExtra: Maybe<EmailOutboundExtraInput>;
  attachments: Maybe<Array<AttachmentInput>>;
  replyToMessageId: Maybe<Scalars['String']>;
  templateArg: Maybe<TemplateArgumentInput>;
};


export type MutationCreateOrUpdatePaymentMethodArgs = {
  args: PaymentMethodInput;
  slug: Scalars['ID'];
};


export type MutationCreateOrderArgs = {
  slug: Scalars['ID'];
  conversationId: Scalars['ID'];
  profileId: Scalars['ID'];
  profileInfo: OrderProfileInfoInput;
  shipmentRequired: Scalars['Boolean'];
  items: Array<OrderItemInput>;
};


export type MutationCreateOrderNoteArgs = {
  slug: Scalars['ID'];
  orderId: Scalars['ID'];
  args: OrderNoteCreateRequestArgs;
};


export type MutationCreateProductArgs = {
  args: CreateProductArgs;
  slug: Scalars['ID'];
};


export type MutationCreateQuickReplyCategoryRequestArgs = {
  slug: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationCreateQuickReplyRequestArgs = {
  slug: Scalars['ID'];
  name: Scalars['String'];
  categoryId: Maybe<Scalars['ID']>;
  content: Scalars['String'];
};


export type MutationCreateRoleArgs = {
  slug: Scalars['ID'];
  companySlug: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  description: Maybe<Scalars['String']>;
  capabilities: CapabilitiesArgs;
  channels: Maybe<Array<RoleChannelArgs>>;
};


export type MutationCreateShopifyAuthorizeLinkArgs = {
  queryString: Scalars['String'];
};


export type MutationCreateShopifyOrderArgs = {
  slug: Scalars['ID'];
  profileId: Scalars['ID'];
  conversationId: Scalars['ID'];
  lineItemInputs: Array<LineItemInput>;
};


export type MutationCreateShopifySubscriptionArgs = {
  slug: Scalars['ID'];
  shopifyPlanId: Scalars['ID'];
};


export type MutationCreateSubscriptionArgs = {
  slug: Scalars['ID'];
  stripePlanId: Scalars['ID'];
  queryStr: Maybe<Scalars['String']>;
};


export type MutationCreateSubscriptionPortalSessionArgs = {
  slug: Scalars['ID'];
};


export type MutationCreateTagArgs = {
  args: CreateTagArgs;
  slug: Scalars['ID'];
};


export type MutationCreateTeamArgs = {
  slug: Scalars['ID'];
  args: CreateTeamArgs;
};


export type MutationCreateWhatsapp2ChannelArgs = {
  accountUrl: Scalars['String'];
  authToken: Scalars['String'];
  channelName: Scalars['String'];
  phone: Scalars['String'];
  slug: Scalars['ID'];
};


export type MutationCreateWhatsappChannelArgs = {
  accountSid: Scalars['String'];
  authToken: Scalars['String'];
  channelName: Scalars['String'];
  phone: Scalars['String'];
  slug: Scalars['ID'];
};


export type MutationCustomerCancelPaymentArgs = {
  slug: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationCustomerInitiatePaymentArgs = {
  slug: Scalars['ID'];
  input: CustomerInitialPaymentInput;
};


export type MutationCustomerQueryPaymentArgs = {
  slug: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationCustomerRemoveAddressArgs = {
  slug: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationCustomerRequestPresignUploadArgs = {
  slug: Scalars['ID'];
  input: CustomerRequestPresignUploadInput;
};


export type MutationCustomerSubmitArgs = {
  slug: Scalars['ID'];
  input: CustomerSubmitInput;
};


export type MutationCustomerUpdateOrderArgs = {
  slug: Scalars['ID'];
  args: CustomerUpdateOrderArgs;
};


export type MutationDeleteCompanyChannelArgs = {
  channelId: Scalars['String'];
  slug: Scalars['ID'];
};


export type MutationDeleteCompanyCommerceArgs = {
  id: Scalars['ID'];
  slug: Scalars['ID'];
};


export type MutationDeleteInvitationArgs = {
  id: Scalars['ID'];
  slug: Scalars['ID'];
};


export type MutationDeleteOrderNoteArgs = {
  slug: Scalars['ID'];
  orderId: Scalars['ID'];
  noteId: Scalars['ID'];
};


export type MutationDeleteQuickReplyCategoryRequestArgs = {
  slug: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteQuickReplyRequestArgs = {
  slug: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteRoleArgs = {
  slug: Scalars['ID'];
  reassignRoleSlug: Maybe<Scalars['ID']>;
};


export type MutationDeleteTagArgs = {
  args: DeleteTagArgs;
  slug: Scalars['ID'];
};


export type MutationDetachTagArgs = {
  conversationId: Scalars['ID'];
  tagId: Scalars['ID'];
};


export type MutationImportCustomersConfirmArgs = {
  slug: Scalars['String'];
  importCustomerId: Scalars['ID'];
};


export type MutationImportCustomersDraftArgs = {
  slug: Scalars['String'];
  importCustomerId: Scalars['ID'];
};


export type MutationInitiateConversationArgs = {
  slug: Scalars['String'];
  channelId: Scalars['ID'];
  externalChannelId: Maybe<Scalars['String']>;
  recipient: Scalars['String'];
  profile: InitiateConversationProfileArgs;
  message: InitiateConversationMessageArgs;
  routedTeamId: Maybe<Scalars['ID']>;
};


export type MutationInitiateConversationWithFbFeedArgs = {
  slug: Scalars['String'];
  conversationId: Scalars['ID'];
  content: Scalars['String'];
  attachments: Maybe<Array<AttachmentInput>>;
  pendingId: Maybe<Scalars['String']>;
};


export type MutationInitiateConversationWithPostCommentArgs = {
  slug: Scalars['String'];
  messageId: Scalars['ID'];
  content: Scalars['String'];
  attachments: Maybe<Array<AttachmentInput>>;
  pendingId: Maybe<Scalars['String']>;
};


export type MutationInitiateConversationWithProfileArgs = {
  slug: Scalars['String'];
  channelId: Scalars['ID'];
  externalChannelId: Maybe<Scalars['String']>;
  profileId: Scalars['ID'];
  routedTeamId: Maybe<Scalars['ID']>;
};


export type MutationInviteCompanyUserByEmailArgs = {
  args: InviteCompanyUserByEmailArgs;
  slug: Scalars['ID'];
};


export type MutationLeaveArgs = {
  id: Scalars['ID'];
};


export type MutationMarkActionTakenArgs = {
  id: Scalars['ID'];
};


export type MutationMarkCreatedByBroadcastArgs = {
  id: Scalars['ID'];
  isCreatedByBroadcast: Scalars['Boolean'];
};


export type MutationMarkReadArgs = {
  id: Scalars['ID'];
};


export type MutationPickupArgs = {
  id: Scalars['ID'];
};


export type MutationPushSubscribeArgs = {
  provider: Scalars['String'];
  token: Scalars['String'];
  topic: Scalars['String'];
};


export type MutationPushUnsubscribeArgs = {
  provider: Scalars['String'];
  token: Scalars['String'];
  topic: Scalars['String'];
};


export type MutationRejectReceiptArgs = {
  id: Scalars['ID'];
  isRejected: Scalars['Boolean'];
  remark: Scalars['String'];
  slug: Scalars['ID'];
};


export type MutationRemoveBroadcastCampaignArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCompanyCrmArgs = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationRemoveConversationArgs = {
  conversationId: Scalars['ID'];
};


export type MutationRemoveGroupNoteArgs = {
  id: Scalars['ID'];
  conversationId: Scalars['ID'];
};


export type MutationRemoveMessageArgs = {
  messageId: Scalars['ID'];
};


export type MutationRemoveNoteArgs = {
  id: Scalars['ID'];
  profileId: Scalars['ID'];
};


export type MutationRemoveProductArgs = {
  id: Scalars['ID'];
  slug: Scalars['ID'];
};


export type MutationRemoveSupportUserArgs = {
  id: Scalars['ID'];
  supportUserId: Scalars['ID'];
};


export type MutationRerouteArgs = {
  id: Scalars['ID'];
  routedTeamId: Scalars['ID'];
};


export type MutationResetPasswordArgs = {
  id: Scalars['ID'];
  args: ResetPasswordArgs;
};


export type MutationRetryBroadcastCampaignArgs = {
  id: Scalars['ID'];
};


export type MutationSendInternalMessageArgs = {
  conversationId: Scalars['ID'];
  subject: Maybe<Scalars['String']>;
  content: Scalars['String'];
  pendingId: Maybe<Scalars['String']>;
  attachments: Maybe<Array<AttachmentInput>>;
};


export type MutationShopifyOauthIntegrationArgs = {
  queryString: Scalars['String'];
  slug: Scalars['ID'];
};


export type MutationSubmitReceiptArgs = {
  orderId: Scalars['ID'];
  receipt: Scalars['String'];
  slug: Scalars['ID'];
};


export type MutationSuspendCompanyArgs = {
  slug: Scalars['ID'];
};


export type MutationSuspendStaffArgs = {
  id: Scalars['ID'];
  args: SuspendStaffArgs;
};


export type MutationToggleConversationLiveChatArgs = {
  id: Scalars['ID'];
  isLiveChat: Scalars['Boolean'];
};


export type MutationUnmarkActionTakenArgs = {
  id: Scalars['ID'];
};


export type MutationUnsuspendCompanyArgs = {
  slug: Scalars['ID'];
};


export type MutationUnsuspendStaffArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateBroadcastCampaignArgs = {
  id: Scalars['ID'];
  slug: Scalars['String'];
  title: Scalars['String'];
  channelId: Scalars['ID'];
  externalChannelId: Maybe<Scalars['String']>;
  subject: Maybe<Scalars['String']>;
  content: Maybe<Scalars['String']>;
  attachments: Maybe<Array<AttachmentInput>>;
  templateId: Maybe<Scalars['String']>;
  templateArg: Maybe<TemplateArgumentInput>;
  deliveryAt: Maybe<Scalars['Date']>;
  selectedCustomersSelect: Maybe<SelectedCustomersSelectInput>;
  selectedCustomersSelectAll: Maybe<SelectedCustomersSelectAllInput>;
  emailExtra: Maybe<EmailOutboundExtraInput>;
  whatsappExtra: Maybe<WhatsappOutboundExtraInput>;
  saveDraft: Scalars['Boolean'];
};


export type MutationUpdateCompanyArgs = {
  args: UpdateCompanyArgs;
  slug: Scalars['ID'];
};


export type MutationUpdateCompanyChannelArgs = {
  args: UpdateCompanyChannelArgs;
  channelId: Scalars['String'];
  slug: Scalars['ID'];
};


export type MutationUpdateCompanyCrmArgs = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  input: UpdateCompanyCrmInput;
};


export type MutationUpdateCustomerPortalSettingsArgs = {
  args: UpdateCustomerPortalSettingsArgs;
  slug: Scalars['ID'];
};


export type MutationUpdateCustomerProfileArgs = {
  id: Scalars['ID'];
  conversationId: Scalars['ID'];
  args: UpdateCustomerProfileArgs;
};


export type MutationUpdateGroupNoteArgs = {
  id: Scalars['ID'];
  conversationId: Scalars['ID'];
  content: Scalars['String'];
};


export type MutationUpdateNoteArgs = {
  id: Scalars['ID'];
  profileId: Scalars['ID'];
  content: Scalars['String'];
};


export type MutationUpdateOnboardingProgressArgs = {
  onboardingProgress: CompanyOnboardingStep;
  slug: Scalars['ID'];
};


export type MutationUpdateOrderArgs = {
  slug: Scalars['ID'];
  id: Scalars['ID'];
  args: UpdateOrderArgs;
};


export type MutationUpdateOrderNoteArgs = {
  slug: Scalars['ID'];
  orderId: Scalars['ID'];
  noteId: Scalars['ID'];
  args: OrderNoteEditRequestArgs;
};


export type MutationUpdatePaymentSettingArgs = {
  args: UpdatePaymentSettingArgs;
  slug: Scalars['ID'];
};


export type MutationUpdateProductArgs = {
  args: UpdateProductArgs;
  id: Scalars['ID'];
  slug: Scalars['ID'];
};


export type MutationUpdateQuickReplyCategoryRequestArgs = {
  slug: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationUpdateQuickReplyRequestArgs = {
  slug: Scalars['ID'];
  name: Scalars['String'];
  content: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationUpdateRoleArgs = {
  slug: Scalars['ID'];
  name: Scalars['String'];
  description: Maybe<Scalars['String']>;
  capabilities: CapabilitiesArgs;
  channels: Maybe<Array<RoleChannelArgs>>;
  conversationAssignee: Maybe<Scalars['String']>;
};


export type MutationUpdateStaffArgs = {
  id: Scalars['ID'];
  args: UpdateStaffArgs;
};


export type MutationUpdateSubscriptionPlanArgs = {
  slug: Scalars['ID'];
  subscriptionPlanId: Scalars['ID'];
  stripePlanId: Maybe<Scalars['ID']>;
  returnUrlQueryStr: Maybe<Scalars['String']>;
};


export type MutationUpdateTagArgs = {
  args: UpdateTagArgs;
  slug: Scalars['ID'];
};


export type MutationUpdateTeamArgs = {
  slug: Scalars['ID'];
  id: Scalars['ID'];
  args: UpdateTeamArgs;
};


export type MutationUpdateTemplatePrefillValuesArgs = {
  slug: Scalars['ID'];
  templateId: Scalars['String'];
  setting: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID'];
  args: UpdateUserArgs;
};

export type NameEmail = {
   __typename: 'NameEmail';
  name: Maybe<Scalars['String']>;
  email: Scalars['String'];
};

export type NameEmailInput = {
  name: Maybe<Scalars['String']>;
  email: Scalars['String'];
};

export type Note = {
   __typename: 'Note';
  id: Scalars['ID'];
  edited: Scalars['Boolean'];
  latestHistory: Maybe<NoteHistory>;
};

export type NoteHistory = {
   __typename: 'NoteHistory';
  createdAt: Scalars['Date'];
  createdBy: Maybe<Scalars['String']>;
  content: Scalars['String'];
};

export type Order = {
   __typename: 'Order';
  assignee: Scalars['ID'];
  billingAddress1: Maybe<Scalars['String']>;
  billingAddress2: Maybe<Scalars['String']>;
  billingCountry: Maybe<Scalars['String']>;
  channelSubType: Maybe<Scalars['String']>;
  channelType: Maybe<Scalars['String']>;
  companyId: Scalars['ID'];
  conversationId: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  customerAddresses: Array<CustomerAddress>;
  customerId: Scalars['ID'];
  customerName: Maybe<Scalars['String']>;
  deliverBy: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items: Array<OrderItem>;
  payments: Array<Payment>;
  shipmentRequired: Scalars['Boolean'];
  shippingAddress1: Maybe<Scalars['String']>;
  shippingAddress2: Maybe<Scalars['String']>;
  shippingCountry: Maybe<Scalars['String']>;
  shippingEmail: Maybe<Scalars['String']>;
  shippingName: Maybe<Scalars['String']>;
  shippingPhone: Maybe<Scalars['String']>;
  status: OrderStatus;
  statusHistories: Array<OrderStatusHistory>;
  trackingNumber: Maybe<Scalars['String']>;
};

export type OrderItem = {
   __typename: 'OrderItem';
  currency: Scalars['String'];
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images: Array<Scalars['String']>;
  name: Scalars['String'];
  quantity: Scalars['Int'];
  sku: Maybe<Scalars['String']>;
  unitPrice: Scalars['String'];
};

export type OrderItemInput = {
  sku: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  unitPrice: Scalars['String'];
  quantity: Scalars['Int'];
  name: Scalars['String'];
  description: Maybe<Scalars['String']>;
  images: Array<Scalars['String']>;
};

export type OrderNote = {
   __typename: 'OrderNote';
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  modifiedAt: Maybe<Scalars['Date']>;
  createdBy: Maybe<Scalars['ID']>;
  modifiedBy: Maybe<Scalars['ID']>;
  content: Scalars['String'];
};

export type OrderNoteCreateRequestArgs = {
  content: Scalars['String'];
};

export type OrderNoteEditRequestArgs = {
  content: Scalars['String'];
};

export type OrderNoteListResponse = {
   __typename: 'OrderNoteListResponse';
  orderNotes: Array<OrderNote>;
  total: Scalars['Int'];
};

export type OrderProfileInfoInput = {
  name: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
};

export type OrderQueryResponse = {
   __typename: 'OrderQueryResponse';
  orders: Array<Order>;
  total: Scalars['Int'];
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  OrderSent = 'ORDER_SENT',
  OutstandingPayment = 'OUTSTANDING_PAYMENT',
  Paid = 'PAID',
  PaymentRejected = 'PAYMENT_REJECTED',
  Processing = 'PROCESSING',
  ReceiptReceived = 'RECEIPT_RECEIVED',
  ReceiptRejected = 'RECEIPT_REJECTED',
  Refunded = 'REFUNDED',
  Refunding = 'REFUNDING',
  Returned = 'RETURNED',
  ReturnHandling = 'RETURN_HANDLING',
  ReturnRejected = 'RETURN_REJECTED',
  ReturnRequest = 'RETURN_REQUEST',
  Shipped = 'SHIPPED'
}

export type OrderStatusExtra = {
   __typename: 'OrderStatusExtra';
  orderId: Scalars['String'];
  status: OrderStatus;
  orderName: Maybe<Scalars['String']>;
  financialStatus: Maybe<Scalars['String']>;
  fulfillmentStatus: Maybe<Scalars['String']>;
};

export type OrderStatusHistory = {
   __typename: 'OrderStatusHistory';
  staffId: Scalars['ID'];
  status: OrderStatus;
  when: Scalars['Date'];
};

export type Payment = {
   __typename: 'Payment';
  amount: Scalars['String'];
  confirmed: Scalars['Boolean'];
  createdAt: Scalars['Date'];
  currency: Scalars['String'];
  id: Scalars['ID'];
  method: PaymentType;
  receipt: Maybe<Scalars['String']>;
  receiptUrl: Maybe<Scalars['String']>;
  staffId: Maybe<Scalars['String']>;
  status: PaymentStatus;
};

export type PaymentExtra = {
   __typename: 'PaymentExtra';
  orderId: Scalars['String'];
  paymentId: Scalars['String'];
  status: PaymentStatus;
  method: PaymentType;
  currency: Scalars['String'];
  amount: Scalars['String'];
};

export type PaymentMethod = {
   __typename: 'PaymentMethod';
  accountId: Maybe<Scalars['String']>;
  collectReceipt: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  noteContent: Maybe<Scalars['String']>;
  noteTitle: Maybe<Scalars['String']>;
  publishableKey: Maybe<Scalars['String']>;
  thankYou: Maybe<Scalars['String']>;
  type: PaymentType;
};

export type PaymentMethodInput = {
  accountId: Maybe<Scalars['String']>;
  accountSecret: Maybe<Scalars['String']>;
  collectReceipt: Maybe<Scalars['Boolean']>;
  isEnabled: Scalars['Boolean'];
  noteContent: Maybe<Scalars['String']>;
  noteTitle: Maybe<Scalars['String']>;
  publishableKey: Maybe<Scalars['String']>;
  type: PaymentType;
  updateAccountSecret: Maybe<Scalars['Boolean']>;
  updatePublishableKey: Maybe<Scalars['Boolean']>;
};

export enum PaymentMethodType {
  Stripe = 'STRIPE'
}

export type PaymentSessionData = {
   __typename: 'PaymentSessionData';
  paymentMethod: PaymentMethodType;
  sessionId: Scalars['ID'];
};

export type PaymentSetting = {
   __typename: 'PaymentSetting';
  paymentMethods: Array<PaymentMethod>;
};

export enum PaymentStatus {
  Authorized = 'AUTHORIZED',
  Cancelled = 'CANCELLED',
  Captured = 'CAPTURED',
  Created = 'CREATED',
  Rejected = 'REJECTED',
  Settled = 'SETTLED',
  Submitted = 'SUBMITTED',
  Timeout = 'TIMEOUT'
}

export type PaymentSubscription = {
   __typename: 'PaymentSubscription';
  currentSubscriptionEnd: Maybe<Scalars['Date']>;
  shopifyPlan: Maybe<ShopifyPlan>;
  status: StatusType;
  stripePlan: Maybe<StripePlan>;
};

export enum PaymentType {
  Cod = 'COD',
  Custom = 'CUSTOM',
  Stripe = 'STRIPE'
}

export type PeerProfileEditedFields = {
   __typename: 'PeerProfileEditedFields';
  name: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
};

export type Post = {
   __typename: 'Post';
  id: Scalars['ID'];
  subject: Maybe<Scalars['String']>;
  textContent: Maybe<Scalars['String']>;
  caption: Maybe<Scalars['String']>;
  postCreatedAt: Maybe<Scalars['Date']>;
  externalPostId: Maybe<Scalars['String']>;
  attachments: Array<Attachment>;
};

export type PostMessageListResponse = {
   __typename: 'PostMessageListResponse';
  messages: Array<MessageWithReplies>;
  next: Scalars['String'];
};

export type PresentmentPrice = {
   __typename: 'PresentmentPrice';
  price: ShopifyPrice;
};

export type PresignRequestHeader = {
   __typename: 'PresignRequestHeader';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Product = {
   __typename: 'Product';
  companyId: Scalars['ID'];
  createdAt: Scalars['Date'];
  currency: Scalars['String'];
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images: Array<Image>;
  name: Scalars['String'];
  shipmentRequired: Scalars['Boolean'];
  sku: Maybe<Scalars['String']>;
  status: ProductStatus;
  summary: Maybe<Scalars['String']>;
  unitPrice: Scalars['String'];
};

export type ProductQueryResponse = {
   __typename: 'ProductQueryResponse';
  products: Array<Product>;
  total: Scalars['Int'];
};

export enum ProductStatus {
  Available = 'AVAILABLE',
  NotAvailable = 'NOT_AVAILABLE'
}

export type Profile = {
   __typename: 'Profile';
  id: Scalars['ID'];
  name: Scalars['String'];
  username: Maybe<Scalars['String']>;
  profilePic: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  editedFields: PeerProfileEditedFields;
};

/** General commerce info, common to all commerce with the same type */
export type Query = {
   __typename: 'Query';
  averageResponseRatePercent: AnalyticsPlatformNullableIntSeries;
  averageResponseTimeSec: AnalyticsPlatformNullableIntSeries;
  broadcastCampaign: BroadcastCampaign;
  broadcastCampaigns: BroadcastCampaignList;
  broadcastStatusList: BroadcastStatusListResponse;
  channelTypes: AllChannelType;
  checkShopifySubscriptionCompleted: CheckPaymentSubscriptionCompletedResponse;
  checkStripeSubscriptionCompleted: CheckStripeSubscriptionCompletedResponse;
  company: Company;
  companyChannelInfo: Maybe<CompanyChannelInfo>;
  companyChannelStatus: CompanyChannel;
  companyChannelStatusHistory: Array<CompanyChannelStatusHistory>;
  companyCommerces: Array<CompanyCommerce>;
  companyCrms: Array<CompanyCrm>;
  conversation: Conversation;
  conversationCount: ConversationCount;
  conversationCountOfSections: Array<ConversationCountOfSection>;
  conversations: Array<Conversation>;
  customerOrder: CustomerOrderResponse;
  customerPaymentMethods: Array<PaymentMethod>;
  groupNotes: Array<GroupNote>;
  integrationKeys: IntegrationKeyResponse;
  listCompanyInfo: ListCompanyInfoResponse;
  managedTeamUsers: ManagedTeamUserList;
  messages: MessageListResponse;
  notes: Array<Note>;
  order: Order;
  orderNotes: OrderNoteListResponse;
  orders: Maybe<OrderQueryResponse>;
  otp: AuthOtpResponse;
  payment: Payment;
  paymentMethods: Array<PaymentMethod>;
  paymentSetting: PaymentSetting;
  postMessages: PostMessageListResponse;
  product: Product;
  products: ProductQueryResponse;
  profile: Profile;
  profileOrders: Maybe<OrderQueryResponse>;
  quickReplies: QuickReplyList;
  quickReplyCategories: QuickReplyCategoryListResponse;
  receivedIncomingMessages: AnalyticsPlatformIntSeries;
  reducedCustomer: ReducedCustomer;
  referral: Maybe<Referral>;
  repliedCount: AnalyticsPlatformIntSeries;
  reportTokens: Array<ReportToken>;
  reports: Array<Report>;
  roleAssignmentInfo: RoleAssignmentInfo;
  roleCount: Scalars['Int'];
  roles: Array<Role>;
  searchBroadcastConversationCustomerInfo: SearchBroadcastConversationCustomerInfoResponse;
  searchConversationNotes: SearchConversationNotesResponse;
  searchConversationWithFbFeed: SearchConversationWithFbFeedResponse;
  searchConversations: SearchConversationResponse;
  searchCustomerInfo: SearchCustomerInfoResponse;
  searchLatestCustomerConversation: SearchLatestCustomerConversationResponse;
  searchMessages: SearchMessageResponse;
  searchProfileNotes: SearchProfileNotesResponse;
  shopifyProducts: Array<ShopifyProduct>;
  staffMembers: StaffListResponse;
  subscriptionPlanAndUsage: SubscriptionPlanAndUsage;
  subscriptionPlans: Array<SubscriptionPlan>;
  tagByIds: Array<Tag>;
  tagByName: Maybe<Tag>;
  tags: TagQueryResponse;
  teams: TeamListResponse;
  templateMessages: TemplateMessageList;
  user: Maybe<User>;
  userAssignRoleInfo: UserRoleAssignmentInfo;
  userMessaged: AnalyticsPlatformInt;
  userTeams: TeamListResponse;
  users: Array<User>;
};


/** General commerce info, common to all commerce with the same type */
export type QueryAverageResponseRatePercentArgs = {
  fromDate: Scalars['String'];
  slug: Scalars['ID'];
  toDate: Scalars['String'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryAverageResponseTimeSecArgs = {
  fromDate: Scalars['String'];
  slug: Scalars['ID'];
  toDate: Scalars['String'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryBroadcastCampaignArgs = {
  id: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryBroadcastCampaignsArgs = {
  slug: Scalars['ID'];
  status: Maybe<Scalars['String']>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryBroadcastStatusListArgs = {
  slug: Scalars['ID'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryCheckShopifySubscriptionCompletedArgs = {
  chargeId: Scalars['String'];
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryCheckStripeSubscriptionCompletedArgs = {
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryCompanyArgs = {
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryCompanyChannelInfoArgs = {
  companyId: Scalars['ID'];
  channelType: Scalars['String'];
  accountId: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryCompanyChannelStatusArgs = {
  accountId: Scalars['String'];
  channelId: Scalars['String'];
  channelType: Scalars['String'];
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryCompanyChannelStatusHistoryArgs = {
  channelId: Scalars['String'];
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryCompanyCommercesArgs = {
  limit: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryCompanyCrmsArgs = {
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryConversationArgs = {
  id: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryConversationCountArgs = {
  slug: Scalars['ID'];
  assignee: Maybe<Scalars['ID']>;
};


/** General commerce info, common to all commerce with the same type */
export type QueryConversationCountOfSectionsArgs = {
  slug: Scalars['ID'];
  assignee: Maybe<Scalars['ID']>;
};


/** General commerce info, common to all commerce with the same type */
export type QueryConversationsArgs = {
  slug: Scalars['ID'];
  filter: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  assignee: Maybe<Scalars['ID']>;
  tagIds: Maybe<Array<Scalars['ID']>>;
  teamIds: Maybe<Array<Scalars['ID']>>;
  channels: Maybe<Array<ConversationChannelFilterInput>>;
  includesArchived: Maybe<Scalars['Boolean']>;
  sort: Maybe<Scalars['String']>;
  mode: Maybe<Scalars['String']>;
};


/** General commerce info, common to all commerce with the same type */
export type QueryCustomerOrderArgs = {
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryCustomerPaymentMethodsArgs = {
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryGroupNotesArgs = {
  conversationId: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryListCompanyInfoArgs = {
  filter: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  q: Maybe<Scalars['String']>;
};


/** General commerce info, common to all commerce with the same type */
export type QueryManagedTeamUsersArgs = {
  slug: Scalars['ID'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  q: Maybe<Scalars['String']>;
  teamId: Maybe<Scalars['ID']>;
};


/** General commerce info, common to all commerce with the same type */
export type QueryMessagesArgs = {
  conversationId: Scalars['ID'];
  direction: MessageListDirection;
  cursor: Scalars['String'];
  limit: Scalars['Int'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryNotesArgs = {
  profileId: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryOrderArgs = {
  slug: Scalars['ID'];
  id: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryOrderNotesArgs = {
  slug: Scalars['ID'];
  orderId: Scalars['ID'];
  offset: Maybe<Scalars['Int']>;
  limit: Maybe<Scalars['Int']>;
};


/** General commerce info, common to all commerce with the same type */
export type QueryOrdersArgs = {
  slug: Scalars['ID'];
  offset: Maybe<Scalars['Int']>;
  limit: Maybe<Scalars['Int']>;
  q: Maybe<Scalars['String']>;
  fromT: Maybe<Scalars['String']>;
  toT: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
};


/** General commerce info, common to all commerce with the same type */
export type QueryPaymentArgs = {
  id: Scalars['ID'];
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryPaymentMethodsArgs = {
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryPaymentSettingArgs = {
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryPostMessagesArgs = {
  conversationId: Scalars['ID'];
  direction: MessageListDirection;
  cursor: Scalars['String'];
  limit: Scalars['Int'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryProductArgs = {
  id: Scalars['ID'];
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryProductsArgs = {
  limit: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
  q: Maybe<Scalars['String']>;
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryProfileArgs = {
  id: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryProfileOrdersArgs = {
  slug: Scalars['ID'];
  profileId: Scalars['ID'];
  offset: Maybe<Scalars['Int']>;
  limit: Maybe<Scalars['Int']>;
  fromT: Maybe<Scalars['String']>;
  toT: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
};


/** General commerce info, common to all commerce with the same type */
export type QueryQuickRepliesArgs = {
  slug: Scalars['ID'];
  offset: Maybe<Scalars['Int']>;
  limit: Maybe<Scalars['Int']>;
  personal: Maybe<Scalars['Boolean']>;
};


/** General commerce info, common to all commerce with the same type */
export type QueryQuickReplyCategoriesArgs = {
  slug: Scalars['ID'];
  offset: Maybe<Scalars['Int']>;
  limit: Maybe<Scalars['Int']>;
};


/** General commerce info, common to all commerce with the same type */
export type QueryReceivedIncomingMessagesArgs = {
  fromDate: Scalars['String'];
  slug: Scalars['ID'];
  toDate: Scalars['String'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryReducedCustomerArgs = {
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryReferralArgs = {
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryRepliedCountArgs = {
  fromDate: Scalars['String'];
  slug: Scalars['ID'];
  toDate: Scalars['String'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryReportTokensArgs = {
  request: ReportTokensRequest;
};


/** General commerce info, common to all commerce with the same type */
export type QueryReportsArgs = {
  company_slug: Scalars['String'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryRoleAssignmentInfoArgs = {
  slug: Scalars['String'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryRoleCountArgs = {
  slug: Maybe<Scalars['String']>;
  q: Maybe<Scalars['String']>;
};


/** General commerce info, common to all commerce with the same type */
export type QueryRolesArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  q: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};


/** General commerce info, common to all commerce with the same type */
export type QuerySearchBroadcastConversationCustomerInfoArgs = {
  slug: Scalars['ID'];
  broadcastConversationId: Maybe<Scalars['ID']>;
  channelId: Maybe<Scalars['ID']>;
  externalChannelId: Maybe<Scalars['String']>;
  selectedCustomersSelect: Maybe<SelectedCustomersSelectInput>;
  selectedCustomersSelectAll: Maybe<SelectedCustomersSelectAllInput>;
  after: Maybe<Scalars['String']>;
  limit: Maybe<Scalars['Int']>;
};


/** General commerce info, common to all commerce with the same type */
export type QuerySearchConversationNotesArgs = {
  slug: Scalars['ID'];
  keyword: Scalars['String'];
  after: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
};


/** General commerce info, common to all commerce with the same type */
export type QuerySearchConversationWithFbFeedArgs = {
  slug: Scalars['ID'];
  feedConversationId: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QuerySearchConversationsArgs = {
  slug: Scalars['ID'];
  keyword: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


/** General commerce info, common to all commerce with the same type */
export type QuerySearchCustomerInfoArgs = {
  slug: Scalars['ID'];
  tagIds: Maybe<Array<Scalars['ID']>>;
  channels: Maybe<Array<ConversationChannelFilterInput>>;
  q: Maybe<Scalars['String']>;
  after: Maybe<Scalars['String']>;
  limit: Maybe<Scalars['Int']>;
};


/** General commerce info, common to all commerce with the same type */
export type QuerySearchLatestCustomerConversationArgs = {
  slug: Scalars['ID'];
  channelType: Scalars['String'];
  accountId: Scalars['String'];
  recipient: Scalars['String'];
};


/** General commerce info, common to all commerce with the same type */
export type QuerySearchMessagesArgs = {
  slug: Scalars['ID'];
  keyword: Scalars['String'];
  after: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
};


/** General commerce info, common to all commerce with the same type */
export type QuerySearchProfileNotesArgs = {
  slug: Scalars['ID'];
  keyword: Scalars['String'];
  after: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryShopifyProductsArgs = {
  lastId: Maybe<Scalars['String']>;
  limit: Maybe<Scalars['Int']>;
  slug: Scalars['ID'];
  title: Maybe<Scalars['String']>;
};


/** General commerce info, common to all commerce with the same type */
export type QueryStaffMembersArgs = {
  roleFilter: Maybe<Scalars['String']>;
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QuerySubscriptionPlanAndUsageArgs = {
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QuerySubscriptionPlansArgs = {
  referrer: Maybe<Scalars['String']>;
};


/** General commerce info, common to all commerce with the same type */
export type QueryTagByIdsArgs = {
  ids: Array<Scalars['ID']>;
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryTagByNameArgs = {
  name: Scalars['String'];
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryTagsArgs = {
  conversationFilter: Maybe<ConversationTagFilterInput>;
  filter: TagFilterInput;
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryTeamsArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  q: Maybe<Scalars['String']>;
  slug: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryTemplateMessagesArgs = {
  slug: Scalars['ID'];
  channelType: Scalars['String'];
  offset: Maybe<Scalars['Int']>;
  limit: Maybe<Scalars['Int']>;
};


/** General commerce info, common to all commerce with the same type */
export type QueryUserArgs = {
  id: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryUserAssignRoleInfoArgs = {
  id: Scalars['ID'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryUserMessagedArgs = {
  fromDate: Scalars['String'];
  slug: Scalars['ID'];
  toDate: Scalars['String'];
};


/** General commerce info, common to all commerce with the same type */
export type QueryUserTeamsArgs = {
  slug: Scalars['ID'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  q: Maybe<Scalars['String']>;
};


/** General commerce info, common to all commerce with the same type */
export type QueryUsersArgs = {
  channelAccessFilter: Maybe<Array<RoleChannelArgs>>;
  excludeRole: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  q: Maybe<Scalars['String']>;
  slug: Scalars['ID'];
};

export type QuickReply = {
   __typename: 'QuickReply';
  id: Scalars['ID'];
  name: Scalars['String'];
  content: Scalars['String'];
  userId: Maybe<Scalars['String']>;
  category: Maybe<BaseQuickReplyCategory>;
};

export type QuickReplyCategory = {
   __typename: 'QuickReplyCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
  quickReplyList: QuickReplyList;
};

export type QuickReplyCategoryListResponse = {
   __typename: 'QuickReplyCategoryListResponse';
  quickReplyCategories: Array<QuickReplyCategory>;
  total: Scalars['Int'];
};

export type QuickReplyCategoryResponse = {
   __typename: 'QuickReplyCategoryResponse';
  name: Scalars['String'];
};

export type QuickReplyList = {
   __typename: 'QuickReplyList';
  messages: Array<QuickReply>;
  total: Scalars['Int'];
};

export type QuickReplyResponse = {
   __typename: 'QuickReplyResponse';
  name: Scalars['String'];
};

export type ReducedBillingAddress = {
   __typename: 'ReducedBillingAddress';
  address1: Maybe<Scalars['String']>;
  address2: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
};

export type ReducedCustomer = {
   __typename: 'ReducedCustomer';
  name: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  addresses: Array<CustomerAddress>;
};

export type ReducedOrder = {
   __typename: 'ReducedOrder';
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
  status: OrderStatus;
  shipmentRequired: Scalars['Boolean'];
  items: Array<OrderItem>;
  channelType: Maybe<Scalars['String']>;
  channelSubType: Maybe<Scalars['String']>;
  deliverBy: Maybe<Scalars['String']>;
  trackingNumber: Maybe<Scalars['String']>;
  portalLocale: Maybe<Scalars['String']>;
};

export type ReducedOrderStatusHistory = {
   __typename: 'ReducedOrderStatusHistory';
  when: Scalars['Date'];
  status: OrderStatus;
};

export type ReducedPayment = {
   __typename: 'ReducedPayment';
  id: Scalars['ID'];
  method: PaymentType;
  currency: Scalars['String'];
  amount: Scalars['String'];
};

export type ReducedShippingInfo = {
   __typename: 'ReducedShippingInfo';
  name: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  address1: Maybe<Scalars['String']>;
  address2: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
};

export type Referral = {
   __typename: 'Referral';
  code: Maybe<Scalars['String']>;
  referrer: Scalars['String'];
};

export type Report = {
   __typename: 'Report';
  reportDescription: Maybe<Scalars['String']>;
  reportName: Maybe<Scalars['String']>;
  resourceDefinition: Scalars['String'];
};

export type ReportToken = {
   __typename: 'ReportToken';
  key: Maybe<Scalars['String']>;
  token: Scalars['String'];
};

export type ReportTokenRequest = {
  key: Maybe<Scalars['String']>;
  params: Scalars['String'];
  resource: Scalars['String'];
};

export type ReportTokensRequest = {
  reportTokenRequests: Array<ReportTokenRequest>;
};

export type ResetPasswordArgs = {
  newPassword: Maybe<Scalars['String']>;
};

export type Role = {
   __typename: 'Role';
  capabilities: Capabilities;
  channels: Maybe<Array<RoleChannel>>;
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isCompanyRole: Scalars['Boolean'];
  name: Scalars['String'];
  slug: Scalars['ID'];
};

export type RoleAssignmentInfo = {
   __typename: 'RoleAssignmentInfo';
  isRemovable: Scalars['Boolean'];
  roleMemberCount: Scalars['Int'];
  removeRoleReassignCandidate: Array<RoleInfo>;
};

export type RoleChannel = {
   __typename: 'RoleChannel';
  channelType: Scalars['String'];
  customName: Scalars['String'];
  externalChannelId: Maybe<Scalars['String']>;
  externalChannelType: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type RoleChannelArgs = {
  channelId: Scalars['String'];
  externalChannelId: Maybe<Scalars['String']>;
};

export type RoleChannelKey = {
   __typename: 'RoleChannelKey';
  channelId: Scalars['String'];
  externalChannelId: Maybe<Scalars['String']>;
};

export type RoleInfo = {
   __typename: 'RoleInfo';
  slug: Scalars['ID'];
  name: Scalars['String'];
  description: Maybe<Scalars['String']>;
  isCompanyRole: Scalars['Boolean'];
};

export type Sanuker = CompanyChannel & {
   __typename: 'Sanuker';
  accountId: Maybe<Scalars['ID']>;
  channelType: ChannelType;
  creatorName: Maybe<Scalars['String']>;
  customName: Maybe<Scalars['String']>;
  defaultRoutedTeamId: Maybe<Scalars['ID']>;
  enableChatbot: Scalars['Boolean'];
  externalChannels: Array<ExternalChannel>;
  id: Scalars['ID'];
  name: Scalars['String'];
  partialAccountSecret: Maybe<Scalars['String']>;
  status: ChannelStatus;
};

export type SanukerTemplate = {
   __typename: 'SanukerTemplate';
  header: Maybe<SanukerTemplateHeader>;
  body: Scalars['String'];
  footer: Maybe<Scalars['String']>;
  buttons: Maybe<Array<SanukerTemplateButton>>;
};

export type SanukerTemplateButton = {
   __typename: 'SanukerTemplateButton';
  type: SanukerTemplateButtonType;
  text: Scalars['String'];
  url: Maybe<Scalars['String']>;
  phoneNum: Maybe<Scalars['String']>;
};

export enum SanukerTemplateButtonType {
  Url = 'Url',
  QuickReply = 'QuickReply',
  Phone = 'Phone'
}

export type SanukerTemplateHeader = {
   __typename: 'SanukerTemplateHeader';
  format: SanukerTemplateHeaderFormatType;
  text: Maybe<Scalars['String']>;
  exampleArgs: Maybe<Array<Scalars['String']>>;
};

export enum SanukerTemplateHeaderFormatType {
  Text = 'Text',
  Image = 'Image',
  Video = 'Video',
  Document = 'Document'
}

export type SearchBroadcastConversationCustomerInfoResponse = {
   __typename: 'SearchBroadcastConversationCustomerInfoResponse';
  customerInfoList: Array<CustomerInfo>;
  next: Maybe<Scalars['String']>;
  count: Scalars['Int'];
};

export type SearchConversationNoteMatch = {
   __typename: 'SearchConversationNoteMatch';
  note: Note;
  relatedProfile: Maybe<Profile>;
  relatedConversation: Maybe<Conversation>;
};

export type SearchConversationNotesResponse = {
   __typename: 'SearchConversationNotesResponse';
  matches: Array<SearchConversationNoteMatch>;
  next: Maybe<Scalars['String']>;
};

export type SearchConversationResponse = {
   __typename: 'SearchConversationResponse';
  conversations: Array<Conversation>;
  next: Maybe<Scalars['String']>;
  count: Scalars['Int'];
};

export type SearchConversationWithFbFeedResponse = {
   __typename: 'SearchConversationWithFbFeedResponse';
  conversation: Maybe<Conversation>;
  lastCommentMessage: Maybe<Message>;
};

export type SearchCustomerInfoResponse = {
   __typename: 'SearchCustomerInfoResponse';
  customerInfoList: Array<CustomerInfo>;
  next: Maybe<Scalars['String']>;
  count: Scalars['Int'];
};

export type SearchLatestCustomerConversationResponse = {
   __typename: 'SearchLatestCustomerConversationResponse';
  conversation: Maybe<CustomerConversation>;
  profile: Maybe<Profile>;
};

export type SearchMessageResponse = {
   __typename: 'SearchMessageResponse';
  matches: Array<DetailedMatchMessage>;
  next: Maybe<Scalars['String']>;
};

export type SearchProfileNoteMatch = {
   __typename: 'SearchProfileNoteMatch';
  profileNote: Note;
  relatedProfile: Profile;
  relatedConversation: Maybe<Conversation>;
};

export type SearchProfileNotesResponse = {
   __typename: 'SearchProfileNotesResponse';
  matches: Array<SearchProfileNoteMatch>;
  next: Maybe<Scalars['String']>;
};

export type SelectedCustomersSelectAllInput = {
  tagIds: Maybe<Array<Scalars['String']>>;
  searchQuery: Maybe<Scalars['String']>;
  exceptCustomerIds: Maybe<Array<Scalars['String']>>;
};

export type SelectedCustomersSelectInput = {
  selectedCustomerIds: Array<Scalars['String']>;
};

export type ShopifyCompanyCommerce = CompanyCommerce & {
   __typename: 'ShopifyCompanyCommerce';
  accountId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ShopifyCreateCommerceRequestArgs = {
  accountId: Scalars['String'];
  name: Scalars['String'];
  queryString: Scalars['String'];
};

export type ShopifyImage = {
   __typename: 'ShopifyImage';
  createdAt: Scalars['Date'];
  height: Scalars['Int'];
  id: Scalars['Float'];
  position: Scalars['Int'];
  productId: Scalars['Float'];
  src: Scalars['String'];
  updatedAt: Scalars['Date'];
  variantIds: Array<Scalars['Float']>;
  width: Scalars['Int'];
};

export type ShopifyOption = {
   __typename: 'ShopifyOption';
  id: Scalars['Float'];
  name: Scalars['String'];
  position: Scalars['Int'];
  productId: Scalars['Float'];
  values: Array<Scalars['String']>;
};

export type ShopifyPlan = {
   __typename: 'ShopifyPlan';
  amount: Scalars['String'];
  currency: Scalars['String'];
  freePeriodLength: Scalars['Int'];
  id: Scalars['ID'];
};

export type ShopifyPrice = {
   __typename: 'ShopifyPrice';
  amount: Scalars['String'];
  currencyCode: Scalars['String'];
};

export type ShopifyProduct = {
   __typename: 'ShopifyProduct';
  bodyHtml: Scalars['String'];
  createdAt: Scalars['Date'];
  handle: Scalars['String'];
  id: Scalars['Float'];
  images: Array<ShopifyImage>;
  options: Array<ShopifyOption>;
  productType: Scalars['String'];
  publishedAt: Scalars['Date'];
  publishedScope: Scalars['String'];
  status: ShopifyProductStatus;
  tags: Scalars['String'];
  templateSuffix: Scalars['String'];
  title: Scalars['String'];
  variants: Array<ShopifyVariant>;
  vendor: Scalars['String'];
};

export enum ShopifyProductStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export type ShopifySubscriptionCreateResponse = {
   __typename: 'ShopifySubscriptionCreateResponse';
  confirmUrl: Scalars['String'];
};

export type ShopifyVariant = {
   __typename: 'ShopifyVariant';
  barcode: Scalars['String'];
  compareAtPrice: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  fulfillmentService: Scalars['String'];
  id: Scalars['Float'];
  imageId: Maybe<Scalars['Float']>;
  inventoryItemId: Maybe<Scalars['Float']>;
  inventoryManagement: Maybe<Scalars['String']>;
  inventoryPolicy: Maybe<Scalars['String']>;
  inventoryQuantity: Maybe<Scalars['Int']>;
  option1: Maybe<Scalars['String']>;
  option2: Maybe<Scalars['String']>;
  option3: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  presentmentPrices: Array<PresentmentPrice>;
  price: Scalars['String'];
  productId: Scalars['Float'];
  sku: Scalars['String'];
  taxCode: Maybe<Scalars['String']>;
  taxable: Scalars['Boolean'];
  title: Scalars['String'];
  weight: Scalars['Float'];
  weightUnit: Scalars['String'];
};

export type StaffListResponse = {
   __typename: 'StaffListResponse';
  assignedConversationCounts: Array<AssignedConversationCount>;
  invitations: Array<Invitation>;
  staffs: Array<User>;
};

export enum StatusType {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type StripePlan = {
   __typename: 'StripePlan';
  amount: Scalars['String'];
  billingType: BillingType;
  chargeIntervalType: IntervalType;
  currency: Scalars['String'];
  freePeriodLength: Scalars['Int'];
  id: Scalars['ID'];
  stripePriceId: Scalars['ID'];
  stripeProductId: Scalars['ID'];
};

export type Subscription = {
   __typename: 'Subscription';
  emailQuota: Scalars['Int'];
  paymentSubscription: Maybe<PaymentSubscription>;
  subscriptionPlan: Maybe<SubscriptionPlan>;
  userQuota: Scalars['Int'];
};

export type SubscriptionCreateResponse = {
   __typename: 'SubscriptionCreateResponse';
  sessionData: PaymentSessionData;
};

export type SubscriptionPlan = {
   __typename: 'SubscriptionPlan';
  emailQuota: Scalars['Int'];
  id: Scalars['ID'];
  isFree: Scalars['Boolean'];
  name: Scalars['String'];
  shopifyPlans: Array<ShopifyPlan>;
  slug: Scalars['ID'];
  stripePlans: Array<StripePlan>;
  userQuota: Scalars['Int'];
};

export type SubscriptionPlanAndUsage = {
   __typename: 'SubscriptionPlanAndUsage';
  emailUsed: Scalars['Int'];
  enabledUsers: Scalars['Int'];
  latestSubscription: Maybe<Subscription>;
  plan: Maybe<SubscriptionPlan>;
  userUsed: Scalars['Int'];
};

export type SubscriptionPlanUpdateResponse = {
   __typename: 'SubscriptionPlanUpdateResponse';
  isPaymentRequired: Scalars['Boolean'];
  stripeSessionData: Maybe<PaymentSessionData>;
  company: Company;
};

export type SubscriptionPortalSessionCreateResponse = {
   __typename: 'SubscriptionPortalSessionCreateResponse';
  sessionUrl: Scalars['String'];
};

export type SupportUser = {
   __typename: 'SupportUser';
  id: Scalars['ID'];
  name: Scalars['String'];
  portraitUrl: Maybe<Scalars['String']>;
};

export type SuspendStaffArgs = {
  handoverStaff: Maybe<Scalars['ID']>;
};

/** conversation count from separate api call */
export type Tag = {
   __typename: 'Tag';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TagFilterInput = {
  limit: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
  q: Maybe<Scalars['String']>;
};

export type TagQueryResponse = {
   __typename: 'TagQueryResponse';
  next: Maybe<Scalars['String']>;
  tags: Array<TagWithConversationCount>;
  total: Scalars['Int'];
};

/** conversation count from server response */
export type TagWithConversationCount = {
   __typename: 'TagWithConversationCount';
  conversationCount: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Team = {
   __typename: 'Team';
  autoCompleteIdleDays: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isCollaborative: Scalars['Boolean'];
  name: Scalars['String'];
  teamUsers: Array<TeamUser>;
};

export type TeamListResponse = {
   __typename: 'TeamListResponse';
  teams: Array<Team>;
  total: Scalars['Int'];
};

export type TeamUser = {
   __typename: 'TeamUser';
  isTeamManager: Scalars['Boolean'];
  user: TeamUserUser;
};

export type TeamUserUser = {
   __typename: 'TeamUserUser';
  id: Scalars['ID'];
  name: Scalars['String'];
  portraitUrl: Maybe<Scalars['String']>;
};

export type TemplateArgument = {
   __typename: 'TemplateArgument';
  media: Maybe<TemplateArgumentMedia>;
  headers: Maybe<Array<Scalars['String']>>;
  bodies: Maybe<Array<Scalars['String']>>;
  buttons: Maybe<Array<Scalars['String']>>;
};

export type TemplateArgumentInput = {
  media: Maybe<TemplateArgumentInputMedia>;
  headers: Maybe<Array<Scalars['String']>>;
  bodies: Maybe<Array<Scalars['String']>>;
  buttons: Maybe<Array<Scalars['String']>>;
};

export type TemplateArgumentInputMedia = {
  assetId: Scalars['String'];
  filename: Scalars['String'];
};

export type TemplateArgumentMedia = {
   __typename: 'TemplateArgumentMedia';
  assetId: Scalars['String'];
  filename: Scalars['String'];
  url: Scalars['String'];
};

/** MessageTemplate */
export type TemplateMessage = {
   __typename: 'TemplateMessage';
  id: Scalars['ID'];
  channelType: Scalars['String'];
  name: Scalars['String'];
  approved: Scalars['Boolean'];
  content: Maybe<Scalars['String']>;
  sanuker: Maybe<SanukerTemplate>;
  prefillValues: Maybe<Scalars['String']>;
};

export type TemplateMessageList = {
   __typename: 'TemplateMessageList';
  messages: Array<TemplateMessage>;
  total: Scalars['Int'];
};

export type UpdateCompanyArgs = {
  description: Maybe<Scalars['String']>;
  logoAsset: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type UpdateCompanyChannelArgs = {
  accountSecret: Maybe<Scalars['String']>;
  customName: Maybe<Scalars['String']>;
  defaultRoutedTeamId: Maybe<Scalars['String']>;
};

export type UpdateCompanyCrmInput = {
  syncContact: Scalars['Boolean'];
  syncConversation: Scalars['Boolean'];
};

export type UpdateCustomerPortalSettingsArgs = {
  locale: Scalars['String'];
};

export type UpdateCustomerProfileArgs = {
  name: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  updateName: Scalars['Boolean'];
  updateEmail: Scalars['Boolean'];
  updatePhone: Scalars['Boolean'];
};

export type UpdateOrderArgs = {
  status: OrderStatus;
  updateDeliverInfo: Maybe<Scalars['Boolean']>;
  deliverBy: Maybe<Scalars['String']>;
  trackingNumber: Maybe<Scalars['String']>;
  updateShippingAddress: Maybe<Scalars['Boolean']>;
  shippingAddress1: Maybe<Scalars['String']>;
  shippingAddress2: Maybe<Scalars['String']>;
  shippingCountry: Maybe<Scalars['String']>;
  updateBillingAddress: Maybe<Scalars['Boolean']>;
  billingAddress1: Maybe<Scalars['String']>;
  billingAddress2: Maybe<Scalars['String']>;
  billingCountry: Maybe<Scalars['String']>;
  updateReceiverInfo: Maybe<Scalars['Boolean']>;
  shippingName: Maybe<Scalars['String']>;
  shippingEmail: Maybe<Scalars['String']>;
  shippingPhone: Maybe<Scalars['String']>;
  statusMessage: Maybe<Scalars['String']>;
};

export type UpdatePaymentSettingArgs = {
  paymentMethods: Maybe<Array<PaymentMethodInput>>;
};

export type UpdateProductArgs = {
  currency: Scalars['String'];
  description: Maybe<Scalars['String']>;
  /** images asset ids */
  images: Array<Scalars['String']>;
  name: Scalars['String'];
  shipmentRequired: Scalars['Boolean'];
  sku: Maybe<Scalars['String']>;
  status: ProductStatus;
  summary: Maybe<Scalars['String']>;
  unitPrice: Scalars['String'];
  updateCurrency: Scalars['Boolean'];
  updateDescription: Scalars['Boolean'];
  updateImages: Scalars['Boolean'];
  updateName: Scalars['Boolean'];
  updateShipmentRequired: Scalars['Boolean'];
  updateSku: Scalars['Boolean'];
  updateStatus: Scalars['Boolean'];
  updateSummary: Scalars['Boolean'];
  updateUnitPrice: Scalars['Boolean'];
};

export type UpdateStaffArgs = {
  name: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  staffCode: Maybe<Scalars['String']>;
};

export type UpdateTagArgs = {
  newName: Scalars['String'];
  tagId: Scalars['ID'];
};

export type UpdateTeamArgs = {
  name: Scalars['String'];
  teamUsers: Array<UpdateTeamUser>;
  autoCompleteIdleDays: Maybe<Scalars['Int']>;
};

export type UpdateTeamUser = {
  userId: Scalars['ID'];
  isTeamManager: Scalars['Boolean'];
};

export type UpdateUserArgs = {
  name: Scalars['String'];
  phone: Maybe<Scalars['String']>;
  portraitAsset: Maybe<Scalars['String']>;
};

export type User = {
   __typename: 'User';
  company: Maybe<Company>;
  email: Scalars['String'];
  id: Scalars['ID'];
  loginUsername: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone: Maybe<Scalars['String']>;
  portraitUrl: Maybe<Scalars['String']>;
  role: Maybe<Role>;
  staffCode: Maybe<Scalars['String']>;
  suspended: Scalars['Boolean'];
};

export type UserOtp = {
   __typename: 'UserOtp';
  userId: Scalars['ID'];
  secret: Scalars['String'];
};

export type UserReassignRoleCandidate = {
   __typename: 'UserReassignRoleCandidate';
  isConversationReassignmentRequired: Scalars['Boolean'];
  role: Role;
};

export type UserRoleAssignmentInfo = {
   __typename: 'UserRoleAssignmentInfo';
  channelsWithAssignedConversations: Array<RoleChannelKey>;
  reassignRoleCandidates: Array<UserReassignRoleCandidate>;
  assignedConversationCount: Scalars['Int'];
};

export type Wechat = CompanyChannel & {
   __typename: 'Wechat';
  accountId: Maybe<Scalars['ID']>;
  channelType: ChannelType;
  creatorName: Maybe<Scalars['String']>;
  customName: Maybe<Scalars['String']>;
  defaultRoutedTeamId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  partialAccountSecret: Maybe<Scalars['String']>;
  status: ChannelStatus;
};

export type Whatsapp = CompanyChannel & {
   __typename: 'Whatsapp';
  accountId: Maybe<Scalars['ID']>;
  channelType: ChannelType;
  creatorName: Maybe<Scalars['String']>;
  customName: Maybe<Scalars['String']>;
  defaultRoutedTeamId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  partialAccountSecret: Maybe<Scalars['String']>;
  status: ChannelStatus;
};

export type Whatsapp2 = CompanyChannel & {
   __typename: 'Whatsapp2';
  accountId: Maybe<Scalars['ID']>;
  accountUrl: Maybe<Scalars['String']>;
  channelType: ChannelType;
  creatorName: Maybe<Scalars['String']>;
  customName: Maybe<Scalars['String']>;
  defaultRoutedTeamId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  partialAccountSecret: Maybe<Scalars['String']>;
  status: ChannelStatus;
};

export type WhatsappOutboundExtraInput = {
  type: Scalars['Int'];
};

export type OrderStatusHistoryFieldsFragment = (
  { __typename: 'OrderStatusHistory' }
  & Pick<OrderStatusHistory, 'when' | 'staffId' | 'status'>
);

export type OrderItemFieldsFragment = (
  { __typename: 'OrderItem' }
  & Pick<OrderItem, 'id' | 'sku' | 'currency' | 'unitPrice' | 'quantity' | 'name' | 'description' | 'images'>
);

export type ReducedShippingInfoFieldsFragment = (
  { __typename: 'ReducedShippingInfo' }
  & Pick<ReducedShippingInfo, 'name' | 'email' | 'phone' | 'address1' | 'address2' | 'country'>
);

export type ReducedBillingAddressFieldsFragment = (
  { __typename: 'ReducedBillingAddress' }
  & Pick<ReducedBillingAddress, 'address1' | 'address2' | 'country'>
);

export type ReducedOrderFieldsFragment = (
  { __typename: 'ReducedOrder' }
  & Pick<ReducedOrder, 'id' | 'createdAt' | 'status' | 'channelType' | 'channelSubType' | 'deliverBy' | 'trackingNumber' | 'shipmentRequired' | 'portalLocale'>
  & { items: Array<(
    { __typename: 'OrderItem' }
    & OrderItemFieldsFragment
  )> }
);

export type ReducedOrderStatusHistoryFieldsFragment = (
  { __typename: 'ReducedOrderStatusHistory' }
  & Pick<ReducedOrderStatusHistory, 'when' | 'status'>
);

export type ReducedPaymentFieldsFragment = (
  { __typename: 'ReducedPayment' }
  & Pick<ReducedPayment, 'id' | 'method' | 'currency' | 'amount'>
);

export type CompanyFieldsFragment = (
  { __typename: 'Company' }
  & Pick<Company, 'logo' | 'logoUrl' | 'name' | 'defaultCustomerPortalLocale'>
);

export type PaymentMethodFieldsFragment = (
  { __typename: 'PaymentMethod' }
  & Pick<PaymentMethod, 'id' | 'type' | 'isEnabled' | 'noteTitle' | 'noteContent' | 'collectReceipt' | 'accountId' | 'publishableKey' | 'thankYou'>
);

export type CustomerRequestPresignUploadResponseFieldsFragment = (
  { __typename: 'CustomerRequestPresignUploadResponse' }
  & Pick<CustomerRequestPresignUploadResponse, 'assetId' | 'url' | 'method'>
  & { headers: Array<(
    { __typename: 'PresignRequestHeader' }
    & Pick<PresignRequestHeader, 'key' | 'value'>
  )> }
);

export type CustomerPaymentInitiateResponseFieldsFragment = (
  { __typename: 'CustomerPaymentInitiateResponse' }
  & Pick<CustomerPaymentInitiateResponse, 'id' | 'token' | 'publishableKey'>
);

export type PaymentFieldsFragment = (
  { __typename: 'Payment' }
  & Pick<Payment, 'id' | 'createdAt' | 'method' | 'status' | 'currency' | 'amount' | 'receipt' | 'receiptUrl' | 'confirmed'>
);

export type CustomerAddressFieldsFragment = (
  { __typename: 'CustomerAddress' }
  & Pick<CustomerAddress, 'id' | 'type' | 'country' | 'address1' | 'address2'>
);

export type ReducedCustomerFieldsFragment = (
  { __typename: 'ReducedCustomer' }
  & Pick<ReducedCustomer, 'name' | 'phone'>
  & { addresses: Array<(
    { __typename: 'CustomerAddress' }
    & CustomerAddressFieldsFragment
  )> }
);

export type CustomerSubmitMutationVariables = {
  slug: Scalars['ID'];
  input: CustomerSubmitInput;
};


export type CustomerSubmitMutation = (
  { __typename: 'Mutation' }
  & Pick<Mutation, 'CustomerSubmit'>
);

export type CustomerRequestPresignUploadMutationVariables = {
  slug: Scalars['ID'];
  input: CustomerRequestPresignUploadInput;
};


export type CustomerRequestPresignUploadMutation = (
  { __typename: 'Mutation' }
  & { CustomerRequestPresignUpload: (
    { __typename: 'CustomerRequestPresignUploadResponse' }
    & CustomerRequestPresignUploadResponseFieldsFragment
  ) }
);

export type CustomerInitiatePaymentMutationVariables = {
  slug: Scalars['ID'];
  input: CustomerInitialPaymentInput;
};


export type CustomerInitiatePaymentMutation = (
  { __typename: 'Mutation' }
  & { CustomerInitiatePayment: (
    { __typename: 'CustomerPaymentInitiateResponse' }
    & CustomerPaymentInitiateResponseFieldsFragment
  ) }
);

export type CustomerQueryPaymentMutationVariables = {
  slug: Scalars['ID'];
  id: Scalars['ID'];
};


export type CustomerQueryPaymentMutation = (
  { __typename: 'Mutation' }
  & { CustomerQueryPayment: (
    { __typename: 'Payment' }
    & PaymentFieldsFragment
  ) }
);

export type CustomerCancelPaymentMutationVariables = {
  slug: Scalars['ID'];
  id: Scalars['ID'];
};


export type CustomerCancelPaymentMutation = (
  { __typename: 'Mutation' }
  & { CustomerCancelPayment: (
    { __typename: 'Payment' }
    & PaymentFieldsFragment
  ) }
);

export type CustomerRemoveAddressMutationVariables = {
  slug: Scalars['ID'];
  id: Scalars['ID'];
};


export type CustomerRemoveAddressMutation = (
  { __typename: 'Mutation' }
  & Pick<Mutation, 'CustomerRemoveAddress'>
);

export type CustomerUpdateOrderMutationVariables = {
  slug: Scalars['ID'];
  args: CustomerUpdateOrderArgs;
};


export type CustomerUpdateOrderMutation = (
  { __typename: 'Mutation' }
  & { CustomerUpdateOrder: (
    { __typename: 'CustomerOrderResponse' }
    & { order: (
      { __typename: 'ReducedOrder' }
      & ReducedOrderFieldsFragment
    ), shippingInfo: (
      { __typename: 'ReducedShippingInfo' }
      & ReducedShippingInfoFieldsFragment
    ), statusHistories: Array<(
      { __typename: 'ReducedOrderStatusHistory' }
      & ReducedOrderStatusHistoryFieldsFragment
    )>, billingAddress: Maybe<(
      { __typename: 'ReducedBillingAddress' }
      & ReducedBillingAddressFieldsFragment
    )>, payments: Array<(
      { __typename: 'ReducedPayment' }
      & ReducedPaymentFieldsFragment
    )> }
  ) }
);

export type CustomerOrderQueryVariables = {
  slug: Scalars['ID'];
};


export type CustomerOrderQuery = (
  { __typename: 'Query' }
  & { customerOrder: (
    { __typename: 'CustomerOrderResponse' }
    & { order: (
      { __typename: 'ReducedOrder' }
      & ReducedOrderFieldsFragment
    ), shippingInfo: (
      { __typename: 'ReducedShippingInfo' }
      & ReducedShippingInfoFieldsFragment
    ), statusHistories: Array<(
      { __typename: 'ReducedOrderStatusHistory' }
      & ReducedOrderStatusHistoryFieldsFragment
    )>, billingAddress: Maybe<(
      { __typename: 'ReducedBillingAddress' }
      & ReducedBillingAddressFieldsFragment
    )>, payments: Array<(
      { __typename: 'ReducedPayment' }
      & ReducedPaymentFieldsFragment
    )> }
  ) }
);

export type CompanyQueryVariables = {
  slug: Scalars['ID'];
};


export type CompanyQuery = (
  { __typename: 'Query' }
  & { company: (
    { __typename: 'Company' }
    & CompanyFieldsFragment
  ) }
);

export type CustomerPaymentMethodsQueryVariables = {
  slug: Scalars['ID'];
};


export type CustomerPaymentMethodsQuery = (
  { __typename: 'Query' }
  & { customerPaymentMethods: Array<(
    { __typename: 'PaymentMethod' }
    & PaymentMethodFieldsFragment
  )> }
);

export type ReducedCustomerQueryVariables = {
  slug: Scalars['ID'];
};


export type ReducedCustomerQuery = (
  { __typename: 'Query' }
  & { reducedCustomer: (
    { __typename: 'ReducedCustomer' }
    & ReducedCustomerFieldsFragment
  ) }
);

export const orderStatusHistoryFields = gql`
    fragment OrderStatusHistoryFields on OrderStatusHistory {
  when
  staffId
  status
}
    `;
export const reducedShippingInfoFields = gql`
    fragment ReducedShippingInfoFields on ReducedShippingInfo {
  name
  email
  phone
  address1
  address2
  country
}
    `;
export const reducedBillingAddressFields = gql`
    fragment ReducedBillingAddressFields on ReducedBillingAddress {
  address1
  address2
  country
}
    `;
export const orderItemFields = gql`
    fragment OrderItemFields on OrderItem {
  id
  sku
  currency
  unitPrice
  quantity
  name
  description
  images
}
    `;
export const reducedOrderFields = gql`
    fragment ReducedOrderFields on ReducedOrder {
  id
  createdAt
  status
  channelType
  channelSubType
  deliverBy
  trackingNumber
  shipmentRequired
  portalLocale
  items {
    ...OrderItemFields
  }
}
    ${orderItemFields}`;
export const reducedOrderStatusHistoryFields = gql`
    fragment ReducedOrderStatusHistoryFields on ReducedOrderStatusHistory {
  when
  status
}
    `;
export const reducedPaymentFields = gql`
    fragment ReducedPaymentFields on ReducedPayment {
  id
  method
  currency
  amount
}
    `;
export const companyFields = gql`
    fragment CompanyFields on Company {
  logo
  logoUrl
  name
  defaultCustomerPortalLocale
}
    `;
export const paymentMethodFields = gql`
    fragment PaymentMethodFields on PaymentMethod {
  id
  type
  isEnabled
  noteTitle
  noteContent
  collectReceipt
  accountId
  publishableKey
  thankYou
}
    `;
export const customerRequestPresignUploadResponseFields = gql`
    fragment CustomerRequestPresignUploadResponseFields on CustomerRequestPresignUploadResponse {
  assetId
  url
  method
  headers {
    key
    value
  }
}
    `;
export const customerPaymentInitiateResponseFields = gql`
    fragment CustomerPaymentInitiateResponseFields on CustomerPaymentInitiateResponse {
  id
  token
  publishableKey
}
    `;
export const paymentFields = gql`
    fragment PaymentFields on Payment {
  id
  createdAt
  method
  status
  currency
  amount
  receipt
  receiptUrl
  confirmed
}
    `;
export const customerAddressFields = gql`
    fragment CustomerAddressFields on CustomerAddress {
  id
  type
  country
  address1
  address2
}
    `;
export const reducedCustomerFields = gql`
    fragment ReducedCustomerFields on ReducedCustomer {
  name
  phone
  addresses {
    ...CustomerAddressFields
  }
}
    ${customerAddressFields}`;
export const gqlCustomerSubmit = gql`
    mutation CustomerSubmit($slug: ID!, $input: CustomerSubmitInput!) {
  CustomerSubmit(slug: $slug, input: $input)
}
    `;
export const gqlCustomerRequestPresignUpload = gql`
    mutation CustomerRequestPresignUpload($slug: ID!, $input: CustomerRequestPresignUploadInput!) {
  CustomerRequestPresignUpload(slug: $slug, input: $input) {
    ...CustomerRequestPresignUploadResponseFields
  }
}
    ${customerRequestPresignUploadResponseFields}`;
export const gqlCustomerInitiatePayment = gql`
    mutation CustomerInitiatePayment($slug: ID!, $input: CustomerInitialPaymentInput!) {
  CustomerInitiatePayment(slug: $slug, input: $input) {
    ...CustomerPaymentInitiateResponseFields
  }
}
    ${customerPaymentInitiateResponseFields}`;
export const gqlCustomerQueryPayment = gql`
    mutation CustomerQueryPayment($slug: ID!, $id: ID!) {
  CustomerQueryPayment(slug: $slug, id: $id) {
    ...PaymentFields
  }
}
    ${paymentFields}`;
export const gqlCustomerCancelPayment = gql`
    mutation CustomerCancelPayment($slug: ID!, $id: ID!) {
  CustomerCancelPayment(slug: $slug, id: $id) {
    ...PaymentFields
  }
}
    ${paymentFields}`;
export const gqlCustomerRemoveAddress = gql`
    mutation CustomerRemoveAddress($slug: ID!, $id: ID!) {
  CustomerRemoveAddress(slug: $slug, id: $id)
}
    `;
export const gqlCustomerUpdateOrder = gql`
    mutation CustomerUpdateOrder($slug: ID!, $args: CustomerUpdateOrderArgs!) {
  CustomerUpdateOrder(slug: $slug, args: $args) {
    order {
      ...ReducedOrderFields
    }
    shippingInfo {
      ...ReducedShippingInfoFields
    }
    statusHistories {
      ...ReducedOrderStatusHistoryFields
    }
    billingAddress {
      ...ReducedBillingAddressFields
    }
    payments {
      ...ReducedPaymentFields
    }
  }
}
    ${reducedOrderFields}
${reducedShippingInfoFields}
${reducedOrderStatusHistoryFields}
${reducedBillingAddressFields}
${reducedPaymentFields}`;
export const gqlCustomerOrder = gql`
    query CustomerOrder($slug: ID!) {
  customerOrder(slug: $slug) {
    order {
      ...ReducedOrderFields
    }
    shippingInfo {
      ...ReducedShippingInfoFields
    }
    statusHistories {
      ...ReducedOrderStatusHistoryFields
    }
    billingAddress {
      ...ReducedBillingAddressFields
    }
    payments {
      ...ReducedPaymentFields
    }
  }
}
    ${reducedOrderFields}
${reducedShippingInfoFields}
${reducedOrderStatusHistoryFields}
${reducedBillingAddressFields}
${reducedPaymentFields}`;
export const gqlCompany = gql`
    query Company($slug: ID!) {
  company(slug: $slug) {
    ...CompanyFields
  }
}
    ${companyFields}`;
export const gqlCustomerPaymentMethods = gql`
    query CustomerPaymentMethods($slug: ID!) {
  customerPaymentMethods(slug: $slug) {
    ...PaymentMethodFields
  }
}
    ${paymentMethodFields}`;
export const gqlReducedCustomer = gql`
    query ReducedCustomer($slug: ID!) {
  reducedCustomer(slug: $slug) {
    ...ReducedCustomerFields
  }
}
    ${reducedCustomerFields}`;
